"use strict";

import "featherlight";
import Hammer from "hammerjs";
import select2 from "select2";
import "./js/slick.min";
import "./js/map/index";
import "./js/contact-us/index";
import "./js/payment/index";
import "./js/skrollr";

//TODO: Check if we need it here
//import './js/youtube-processor';

import { TweenMax, TimelineMax } from "gsap";
import ScrollMagic from "scrollmagic";
import "imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap";

import Snap from "snapsvg-cjs";

import SmoothScroll from "smooth-scroll";
import Odometer from "odometer";
// import CountUp from 'countup.js';
import Request from "./js/request";

import Swiper from 'swiper';
import { EffectFade, Autoplay, Navigation } from 'swiper/modules';

import "swiper/swiper.less";
import "swiper/modules/autoplay.less";
import "swiper/modules/effect-fade.less";
import 'swiper/modules/navigation.less';

import 'social-share-button';

// import Bouncer from 'formbouncerjs';

import Plyr from 'plyr';

let isMobile = false,
  is_landscape = window.innerWidth > window.innerHeight,
  animated_stuff = [],
  scrollTimer = null;

const anchorScrollOffset = 160;

if (/Mobi/i.test(navigator.userAgent) || /Android/i.test(navigator.userAgent)) {
  isMobile = true;
}

$(() => {
  var imagesLoaded = require("imagesloaded");
  imagesLoaded.makeJQueryPlugin($);
  var bLazy = new Blazy({
    offset: 50,
    error: function (ele, msg) {
      console.log("b-lazy", msg);
      console.log("ele", ele);
    },
  });

  window.addEventListener("orientationchange", () => {
    is_landscape = window.innerWidth > window.innerHeight;
    $("body").removeClass("menu_open");
  });

  bindBackButton();

  initBannerSlideShow();

  setTimeout(initAlertBannerSwiper, 100);
  
  initFaqCarousel();

  initQuotesCarousel();

  initContentImageSliders();

  bindVideoPlayButtons();

  bindDataLinks();

  bindFilters();

  bindSelect2();

  bindPersonModals();

  bindHospitalDetailModals();

  bindScrollLinks();

  bindPopupBlocks();

  bindLinkedOptions();

  bindPrintButton();

  handleHomeslide();

  bindRouteToCardLink();

  bindMenuCollapse();

  bindMegaDropdowns();

  bindSearchResults();

  bindMenuSwitcher("#tabs_here");

  bindSpecialtyLink();

  bindNaviLinks();

  sortSpecs();

  sortOtherSpecialistsBySurname();

  bindNestedTabs();

  initBloodClotsTool();

  bindDownloadLinks();

  checkAlertModal();
  
  checkEntryPopupModal();

  checkExitPopupModal();

  sizeTheVideo();

  formCheck();

  hiddenTextTrigger();
  registerTabClicks();

  bindAccordionToggleButton();

  updateHash();
  $(window).resize(function () {
    sizeTheVideo();
  });

  if (!$(".visible-xs").is(":visible")) {
  
    initBcAnim();

    if ($(".landing-favourites").length) initFavourites();
  }

  if ($('[class*="landing-infection-prevention"]').length)
    infectionPreventionAnimTriggering();
  if ($('[class*="landing-hand-hygiene"]').length) handHygieneAnimTriggering();
  if ($("#patientSurvey").length) patientSurveyAnimTriggering();
  if ($(".blood-clots-patients-survey").length) {
    bloodClotsPatientsSurvey();
  }

  bindExternalLinks();

  cwsInfographic();

  jobsFilter();

  if (document.getElementById('workplace-health-callback-form') ) {
    ajaxExpressForm( 'workplace-health-callback-form' )
  }

  initFormValidation()

  let targetSelector;
  if ($( "a.initial-anchor" ).length) {
    targetSelector = $($( "a.initial-anchor" ).first().attr("href"));
  }
  if (targetSelector && targetSelector.length) {
    setTimeout(function(){ 
      $("html, body").animate(
        {
          scrollTop: targetSelector.offset().top - anchorScrollOffset,
        },
        1000
      );
    }, 1000);
  }



  let player;
  const videosBlocks = document.querySelectorAll( '.section-video-modal' );
  if ( videosBlocks.length ) {
      videosBlocks.forEach(
          videosBlock => {
              $(videosBlock).on('show.bs.modal', function (e) {
                  const youtubeVideoId = e.relatedTarget.dataset.youtubeId
                  $( videosBlock ).find( '.player iframe' ).attr('src', `https://www.youtube.com/embed/${ youtubeVideoId }?origin=https://plyr.io&iv_load_policy=3&modestbranding=1&playsinline=1&showinfo=0&rel=0&enablejsapi=1`)

                  const playerSelector = `#${videosBlock.id} .video-modal-content .player`
                  const playerOption = {
                  }
                  player = new Plyr( playerSelector, playerOption );
              })
              $(videosBlock).on('hidden.bs.modal', function (e) {
                  if ( player ) {
                      player.destroy()
                  }
              })
          }
      );
  }


});

function checkAlertModal() {
  let alert_modal = $("#alert_modal");
  let alert_shown_on_site =
    sessionStorage.getItem("alert_shown_on_site") === "yes";

  if (alert_modal.length && !alert_shown_on_site) {
    alert_modal.modal("show");
    sessionStorage.setItem("alert_shown_on_site", "yes");
  }

  const alertBanner = $("#alert-banner");
  const alertBannerPlaceholder = $("#alert-banner-placeholder");
  let isAlertBannerShown =
    sessionStorage.getItem("isAlertBannerShown") === "yes";
  if (isAlertBannerShown && alertBanner.length) {
    alertBanner.alert("close");
    alertBannerPlaceholder.alert("close");
  } else {
    alertBanner.removeClass("d-none");
    alertBannerPlaceholder.removeClass("d-none");
  }
  alertBanner.on("close.bs.alert", () => {
    alertBannerPlaceholder.alert("close");
    sessionStorage.setItem("isAlertBannerShown", "yes");
  });
}
function checkEntryPopupModal() {
  let popup_modal = $("#entry_popup_modal");
  let popup_shown_on_site =
    sessionStorage.getItem("popup_shown_on_site") === "yes";

  if (popup_modal.length && !popup_shown_on_site) {
    setTimeout(function() {
      popup_modal.modal("show");
      sessionStorage.setItem("popup_shown_on_site", "yes");
    }, 3000); // 3 second delay (3000 milliseconds)
  }

  // add event listener to the popup button to set the exit not to show if clicked
  $('.entry-watch-btn').on('click', function(e) {
    e.preventDefault();
    sessionStorage.setItem("exit_popup_shown_on_site", "yes");
    // navigate to the link
      window.open($(this).attr('href'), '_blank');
  });
}

function checkExitPopupModal() {
  let exit_popup_modal = $("#exit_popup_modal");
  // sessionStorage.setItem("exit_popup_shown_on_site", "no");
  let exit_popup_shown_on_site = sessionStorage.getItem("exit_popup_shown_on_site") == "yes";
  console.log("exit_popup_shown_on_site", exit_popup_shown_on_site);

  if (exit_popup_modal.length && !exit_popup_shown_on_site) {
    // add listener to capture mouse movement to top of page
    document.addEventListener('mouseout', function(e) {
      exit_popup_shown_on_site = sessionStorage.getItem("exit_popup_shown_on_site") == "yes";
      if (e.clientY < 2 && !exit_popup_shown_on_site) {
        exit_popup_modal.modal("show");
        sessionStorage.setItem("exit_popup_shown_on_site", "yes");
        // remove the listener after showing the modal
        document.removeEventListener('mouseout');
      }
    });



    document.addEventListener('click', function(e) {
      // Find the closest ancestor that is an <a> tag
      const link = e.target.closest('a');

      if (link && link.href && !exit_popup_shown_on_site && !link.classList.contains('exit-popup-ignore')) {
        e.preventDefault();
        exit_popup_modal.modal("show");
        sessionStorage.setItem("exit_popup_shown_on_site", "yes");
        
        // set the modal close button to navigate to the link
        $('#exit_popup_button_' + exit_popup_modal.data('popup-id')).on('click', function(e) {
          window.location.href = link.href;
        });
        // set clicking outside the modal to navigate to the link in a new tab
        exit_popup_modal.on('hidden.bs.modal', function (e) {
          window.open(link.href, '_blank');
        });

        return false;
      }
    });
  }
}

function initAlertBannerSwiper() {
  const alertBannerSwiperContainers = document.querySelectorAll( '.alert-banner-swiper-container .swiper' );
  if ( alertBannerSwiperContainers.length ) {
    alertBannerSwiperContainers.forEach( alertBannerSwiperContainer => {
        let swiper = new Swiper( alertBannerSwiperContainer, {
          modules: [EffectFade, Autoplay],
          slidesPerView: 1,
          loop: true,
          loopPreventsSliding: false,
          loopAddBlankSlides: true,
          autoplay: {
            delay: 4000,
          },
          spaceBetween: 30,
          speed: 500,
          effect: "fade",
          fadeEffect: {
              crossFade: true
          }
        })
      }
    )
  }
}

function initBcAnim() {
  const controller = new ScrollMagic.Controller();
  const scroll = new SmoothScroll();

  const sceneTrigger1 = "#bc_scene_1";
  const sceneTrigger3 = "#bc_scene_3";
  const sceneTrigger4 = "#bc_scene_4";
  const sceneTrigger5 = "#bc_scene_5";

  const anchor = document.querySelector("#bc_anchor_start");

  if ($("#bc_scene_1").length) {
    setTimeout(function () {
      if (document.body.scrollTop === 0) {
        scroll.animateScroll(anchor);
      }
    }, 1500);

    // Scene 1

    const scene1 = new ScrollMagic.Scene({
      triggerElement: sceneTrigger1,
      offset: 180,
      duration: 400,
      reverse: false,
    }).on("start", function () {
      const num1 = new Odometer({
        el: document.getElementById("bc_num_nz"),
      });

      const num11 = new Odometer({
        el: document.getElementById("bc_num_nz_1"),
        format: "(,ddd)",
      });

      const num2 = new Odometer({
        el: document.getElementById("bc_num_sx"),
      });

      const num21 = new Odometer({
        el: document.getElementById("bc_num_sx_1"),
        format: "(,ddd)",
      });

      num1.update(4.4);
      num11.update(22727);

      num2.update(3.1);
      num21.update(32258);

      $(sceneTrigger1).addClass("animate");
    });

    // Scene 3

    const scene3 = new ScrollMagic.Scene({
      triggerElement: sceneTrigger3,
      offset: 50,
      duration: 400,
      reverse: false,
    }).on("start", function (event) {
      let items = $(sceneTrigger3).find(".stat > div");

      items.each(function () {
        let $this = $(this);
        let $num = $this.find("div > span");
        let percent = $this.data("percent");
        let width = 0;

        $this.closest(".item").find(".stat").addClass("ok");

        let interval = setInterval(function () {
          if (width < percent) {
            width++;
            $num.text(width);
            $this.css("flex", "0 0 " + width + "%");
          } else {
            clearInterval(interval);
          }
        }, 20);
      });
    });

    // Scene 4

    const scene4 = new ScrollMagic.Scene({
      triggerElement: sceneTrigger4,
      offset: 50,
      duration: 400,
      reverse: false,
    }).on("start", function () {
      $(sceneTrigger4).addClass("animate");
    });

    // Scene 5

    const scene5 = new ScrollMagic.Scene({
      triggerElement: sceneTrigger5,
      offset: 50,
      duration: 400,
      reverse: false,
    }).on("start", function () {
      $(sceneTrigger5).addClass("animate");
    });

    controller.addScene([scene1, scene3, scene4, scene5]);
  }
}

function initFavourites() {
  const scrollr = skrollr.init({
    forceHeight: false,
    mobileCheck: function () {
      //hack - forces mobile version to be off
      return false;
    },
  });

  const controller = new ScrollMagic.Controller();

  const helloParallax = new ScrollMagic.Scene({
    triggerElement: ".landing-favourites-hello",
    triggerHook: 1,
    duration: 900,
  })
    .setTween(
      new TimelineMax().add([
        TweenMax.from(".landing-favourites-hello .text", 1, {
          y: "15%",
          ease: Power0.easeNone,
        }),
        TweenMax.from(".tessa", 1, { y: "30%", ease: Power0.easeNone }),
      ])
    )
    .addTo(controller);

  const backyardParallax = new ScrollMagic.Scene({
    triggerElement: ".landing-favourites-backyard",
    triggerHook: 1,
    duration: 900,
    reverse: true,
  })
    .setTween(
      new TimelineMax().add([
        TweenMax.from(".landing-favourites-backyard .heading", 1, {
          y: "50%",
          ease: Power0.easeNone,
        }),
        TweenMax.from(".landing-favourites-backyard .text", 1, {
          y: "50%",
          ease: Power0.easeNone,
        }),
        TweenMax.from(".dwarf", 1, { y: "-35%", ease: Power0.easeNone }),
        TweenMax.from(".fence", 1, { y: "75%", ease: Power0.easeNone }),
      ])
    )
    .addTo(controller);

  const piggiesParallax = new ScrollMagic.Scene({
    triggerElement: ".landing-favourites-piggies",
    triggerHook: 1,
    duration: 900,
  })
    .setTween(
      new TimelineMax().add([
        TweenMax.from(".landing-favourites-piggies .heading", 1, {
          y: "40%",
          opacity: 0,
          ease: Power0.easeNone,
        }),
        TweenMax.from(".landing-favourites-piggies .text", 1, {
          y: "40%",
          opacity: 0,
          ease: Power0.easeNone,
        }),
        TweenMax.from(".piggy", 1, { y: "30%", ease: Power0.easeNone }),
      ])
    )
    .addTo(controller);

  const pjsParallax = new ScrollMagic.Scene({
    triggerElement: ".landing-favourites-pjs",
    triggerHook: 1,
    duration: 900,
  })
    .setTween(
      new TimelineMax().add([
        TweenMax.from(".landing-favourites-pjs .heading", 1, {
          y: "40%",
          opacity: 0,
          ease: Power0.easeNone,
        }),
        TweenMax.from(".landing-favourites-pjs .text", 1, {
          y: "40%",
          opacity: 0,
          ease: Power0.easeNone,
        }),
        TweenMax.from(".women", 1, { y: "-30%", ease: Power0.easeNone }),
      ])
    )
    .addTo(controller);

  const robotsHeadingParallax = new ScrollMagic.Scene({
    triggerElement: ".landing-favourites-robots",
    triggerHook: 1,
    duration: 900,
  })
    .setTween(
      new TimelineMax().add([
        TweenMax.from(".landing-favourites-robots .heading", 1, {
          y: "40%",
          opacity: 0,
          ease: Power0.easeNone,
        }),
        TweenMax.from(".landing-favourites-robots .text", 1, {
          y: "40%",
          opacity: 0,
          ease: Power0.easeNone,
        }),
        TweenMax.from(".robots", 1, { y: "-20%", ease: Power0.easeNone }),
      ])
    )
    .addTo(controller);

  const dishesParallax = new ScrollMagic.Scene({
    triggerElement: ".landing-favourites-dishes",
    triggerHook: 1,
    duration: 900,
  })
    .setTween(
      new TimelineMax().add([
        TweenMax.from(".landing-favourites-dishes .heading", 1, {
          y: "40%",
          opacity: 0,
          ease: Power0.easeNone,
        }),
        TweenMax.from(".landing-favourites-dishes .text", 1, {
          y: "40%",
          opacity: 0,
          ease: Power0.easeNone,
        }),
        TweenMax.from(".dishes-1", 1, { y: "30%", ease: Power0.easeNone }),
        TweenMax.from(".dishes-2", 1, { y: "70%", ease: Power0.easeNone }),
      ])
    )
    .addTo(controller);
}

function infectionPreventionAnimTriggering() {
  const colourBlue = "#007DB9";
  const colourBlueLight = "#3093CC";
  const colourYellow = "#F3D03E";
  const colourOrange = "#FC6014";
  const colourMandarin = "#FC6014";
  const colourPink = "#D8346B";
  const colourGrape = "#692C86";
  const colourTeal = "#5FBCBF";
  const colourGreen = "#97CA3D";

  const controller = new ScrollMagic.Controller();

  const svg2 = $(".landing-infection-prevention-2").find("svg");

  const circle3 = Snap("#svgInfectionPreventionCircle3");

  const circle3Path1 = circle3
    .path(
      "M24.6952,36.8095 C24.6952,37.4625 24.1642,37.9925 23.5122,37.9925 L21.8262,37.9925 C21.1742,37.9925 20.6432,37.4625 20.6432,36.8095 C20.6432,36.1575 21.1742,35.6265 21.8262,35.6265 L23.5122,35.6265 C24.1642,35.6265 24.6952,36.1565 24.6952,36.8095 M25.2892,34.1065 C25.2892,34.7585 24.7592,35.2895 24.1062,35.2895 L21.2322,35.2895 C20.5792,35.2895 20.0492,34.7585 20.0492,34.1065 C20.0492,33.4535 20.5792,32.9225 21.2322,32.9225 L24.1062,32.9225 C24.7592,32.9225 25.2892,33.4535 25.2892,34.1065 M19.9312,31.4025 C19.9312,30.7505 20.4622,30.2195 21.1142,30.2195 L24.2242,30.2195 C24.8762,30.2195 25.4072,30.7505 25.4072,31.4025 C25.4072,32.0555 24.8762,32.5865 24.2242,32.5865 L21.1142,32.5865 C20.4622,32.5865 19.9312,32.0555 19.9312,31.4025 M22.6702,48.2845 C19.9232,48.2775 17.6882,46.8335 17.6882,45.0655 C17.6882,43.7255 19.0582,42.4985 21.0062,42.0395 C21.2092,42.5325 21.6292,42.9245 22.1592,43.0805 C22.1712,43.0845 22.1842,43.0885 22.1892,43.0895 C22.2322,43.1015 22.2762,43.1125 22.3192,43.1205 C22.3452,43.1255 22.3702,43.1295 22.3962,43.1335 L22.4112,43.1355 C22.4112,43.1355 22.4232,43.1375 22.4242,43.1375 C22.4462,43.1415 22.4692,43.1445 22.4902,43.1465 C22.6082,43.1585 22.7312,43.1585 22.8462,43.1465 C22.8692,43.1445 22.8922,43.1415 22.9152,43.1375 L22.9422,43.1335 C22.9672,43.1295 22.9932,43.1255 23.0182,43.1215 C23.0622,43.1125 23.1062,43.1015 23.1422,43.0905 C23.1512,43.0885 23.1712,43.0835 23.1792,43.0805 C23.7092,42.9245 24.1292,42.5325 24.3322,42.0395 C26.2802,42.4985 27.6502,43.7255 27.6502,45.0655 C27.6502,46.8335 25.4152,48.2775 22.6702,48.2845 M17.6472,51.6315 C17.1362,51.6315 16.7202,51.2165 16.7202,50.7045 C16.7202,50.1935 17.1362,49.7775 17.6472,49.7775 C18.1582,49.7775 18.5742,50.1935 18.5742,50.7045 C18.5742,51.2165 18.1582,51.6315 17.6472,51.6315 M27.6912,51.6315 C27.1802,51.6315 26.7642,51.2165 26.7642,50.7045 C26.7642,50.1935 27.1802,49.7775 27.6912,49.7775 C28.2022,49.7775 28.6182,50.1935 28.6182,50.7045 C28.6182,51.2165 28.2022,51.6315 27.6912,51.6315 M31.9162,35.5045 C34.3792,35.5045 35.9712,37.3015 35.9712,40.0805 C35.9712,41.7505 34.3842,42.9805 32.9842,44.0655 C32.0372,44.7995 31.0582,45.5585 31.0582,46.1345 C31.0582,47.0325 31.4802,47.6475 31.8882,48.2425 C32.2182,48.7245 32.5302,49.1795 32.5302,49.7185 C32.5302,50.5365 31.6762,50.9005 30.9902,51.1945 C30.7262,51.3075 30.2892,51.4935 30.1992,51.6145 C30.1912,51.7255 30.1962,51.8795 30.2022,52.0415 C30.2222,52.6375 30.2492,53.4535 29.7172,54.0035 C29.3922,54.3395 28.9182,54.5105 28.3082,54.5105 C26.8912,54.5105 26.4322,53.7485 26.0272,53.0765 C25.8112,52.7185 25.6082,52.3805 25.2512,52.1035 C24.2402,51.3205 22.6842,51.3055 22.6682,51.3055 C22.6542,51.3055 21.0982,51.3205 20.0872,52.1035 C19.7302,52.3805 19.5262,52.7185 19.3112,53.0765 C18.9062,53.7485 18.4472,54.5105 17.0302,54.5105 C16.4202,54.5105 15.9462,54.3395 15.6212,54.0035 C15.0892,53.4535 15.1162,52.6375 15.1362,52.0415 C15.1412,51.8795 15.1462,51.7255 15.1392,51.6145 C15.0482,51.4935 14.6122,51.3075 14.3482,51.1945 C13.6622,50.9015 12.8082,50.5365 12.8082,49.7185 C12.8082,49.1795 13.1202,48.7245 13.4502,48.2425 C13.8582,47.6475 14.2802,47.0325 14.2802,46.1345 C14.2802,45.5585 13.3012,44.7995 12.3542,44.0655 C10.9542,42.9805 9.3672,41.7505 9.3672,40.0805 C9.3672,37.3015 10.9582,35.5045 13.4222,35.5045 C15.7142,35.5045 17.1122,35.7745 19.3372,37.3775 C20.9812,38.5625 22.1912,39.2555 22.6692,39.5165 C23.1472,39.2555 24.3562,38.5625 26.0012,37.3775 C28.2262,35.7745 29.6242,35.5045 31.9162,35.5045 Z M58.7309,38.2021 C60.7269,36.4301 61.9709,34.1491 63.1319,31.8251 C63.4599,31.1701 63.7759,30.5091 64.0869,29.8451 C64.1879,29.6281 64.4179,29.5041 64.6539,29.5361 C65.1909,29.6081 65.7179,29.7121 66.2329,29.8441 C66.5539,29.9261 66.7209,30.2801 66.5889,30.5841 C65.7569,32.4981 64.9549,34.4251 64.1709,36.3591 C63.6699,37.5961 63.7909,38.8131 64.5509,39.9721 C65.2739,41.0751 65.1599,42.2031 64.3279,43.2091 C63.5799,44.1141 61.8209,44.1251 61.4129,43.0261 C61.1059,42.1971 60.4319,41.9031 59.5659,41.8801 C58.3899,41.8481 57.6169,40.8321 57.9339,39.6931 C58.0829,39.1581 58.3329,38.5561 58.7309,38.2021 Z M67.0702,45.6904 C66.3102,47.0104 66.5652,48.2004 67.2592,49.3914 C68.1382,50.9004 69.0252,52.4044 69.9142,53.9074 C70.1742,54.3464 70.0262,54.9164 69.5822,55.1674 C69.1932,55.3884 68.7922,55.5914 68.3812,55.7744 C67.9482,55.9664 67.4392,55.7974 67.2092,55.3844 C67.1452,55.2694 67.0812,55.1554 67.0162,55.0424 C65.7882,52.8854 64.5692,50.7174 62.8442,48.9004 C62.3042,48.3314 61.7652,47.8124 60.8192,48.2284 C60.2802,48.4654 59.7922,48.0324 59.5022,47.5664 C58.8712,46.5514 58.8422,45.4824 59.3942,44.4204 C59.6692,43.8944 60.1202,43.7024 60.6612,44.0164 C62.0982,44.8474 63.4012,44.5964 64.6992,43.6634 C65.5832,43.0284 66.0992,43.0534 66.6812,43.5554 C67.2742,44.0674 67.5282,44.8964 67.0702,45.6904 Z M58.8935,42.8613 C59.2555,43.1203 59.3245,43.5063 59.2355,43.6413 C59.0535,43.9163 58.8185,44.1283 58.5255,44.1463 C57.5355,44.1263 56.9065,43.7733 56.5575,43.1733 C55.8265,41.9213 55.5505,40.5603 56.1615,39.1603 C56.2575,38.9393 56.5275,38.6063 56.7755,38.6403 C57.1125,38.6563 57.1385,39.1133 57.1305,39.3423 C57.0745,40.8513 57.6935,41.9803 58.8935,42.8613 Z M71.2739,54.033 C71.1629,54.119 71.0569,54.21 70.9379,54.288 C70.7019,54.396 70.5819,54.212 70.5539,54.16 C70.1009,53.411 69.6489,52.661 69.2099,51.904 C68.6449,50.932 68.1969,49.889 67.6049,48.934 C67.0119,47.976 66.7549,47.06 67.4089,46.042 C67.4269,46.015 67.4409,45.981 67.4519,45.947 C67.5519,45.643 67.8729,45.457 68.1699,45.573 C68.6019,45.743 68.7239,46.134 68.5729,46.685 C68.4679,47.066 68.5209,47.568 68.6849,47.933 C69.5439,49.833 70.4339,51.722 71.3269,53.607 C71.3269,53.607 71.4579,53.858 71.2739,54.033 Z"
    )
    .attr({
      fill: "#929294",
    });

  const circle3Path2 = circle3
    .path(
      "M45,51 C41.686121,51 39,48.3125723 39,44.9994661 C39,41.6852923 41.686121,39 45,39 C48.313879,39 51,41.6852923 51,44.9994661 C51,48.3125723 48.313879,51 45,51 Z M46,44 L46,42 C46,41.4477153 45.5522847,41 45,41 C44.4477153,41 44,41.4477153 44,42 L44,44 L42,44 C41.4477153,44 41,44.4477153 41,45 C41,45.5522847 41.4477153,46 42,46 L44,46 L44,48 C44,48.5522847 44.4477153,49 45,49 C45.5522847,49 46,48.5522847 46,48 L46,46 L48,46 C48.5522847,46 49,45.5522847 49,45 C49,44.4477153 48.5522847,44 48,44 L46,44 Z"
    )
    .attr({
      fill: "#F79C4B",
    });

  const circle3First = circle3.circle(45, 45, 42).attr({
    fill: "none",
    strokeDasharray: "263.76",
    strokeDashoffset: "263.76",
    stroke: "#F79C4B",
    strokeWidth: "5",
    transform: "scale(1, -1) translate(0, -90) rotate(r89, 45, 45)",
  });

  const circle4 = Snap("#svgInfectionPreventionCircle4");

  const circle4Path1 = circle4
    .path(
      "M45,51 C41.686121,51 39,48.3125723 39,44.9994661 C39,41.6852923 41.686121,39 45,39 C48.313879,39 51,41.6852923 51,44.9994661 C51,48.3125723 48.313879,51 45,51 Z M46,44 L46,42 C46,41.4477153 45.5522847,41 45,41 C44.4477153,41 44,41.4477153 44,42 L44,44 L42,44 C41.4477153,44 41,44.4477153 41,45 C41,45.5522847 41.4477153,46 42,46 L44,46 L44,48 C44,48.5522847 44.4477153,49 45,49 C45.5522847,49 46,48.5522847 46,48 L46,46 L48,46 C48.5522847,46 49,45.5522847 49,45 C49,44.4477153 48.5522847,44 48,44 L46,44 Z"
    )
    .attr({
      fill: colourGrape,
    });

  const circle4Path2 = circle4
    .path(
      "M25.6962,36.8095 C25.6962,37.4625 25.1652,37.9925 24.5132,37.9925 L22.8272,37.9925 C22.1752,37.9925 21.6442,37.4625 21.6442,36.8095 C21.6442,36.1575 22.1752,35.6265 22.8272,35.6265 L24.5132,35.6265 C25.1652,35.6265 25.6962,36.1565 25.6962,36.8095 M26.2902,34.1065 C26.2902,34.7585 25.7602,35.2895 25.1072,35.2895 L22.2332,35.2895 C21.5802,35.2895 21.0502,34.7585 21.0502,34.1065 C21.0502,33.4535 21.5802,32.9225 22.2332,32.9225 L25.1072,32.9225 C25.7602,32.9225 26.2902,33.4535 26.2902,34.1065 M20.9322,31.4025 C20.9322,30.7505 21.4632,30.2195 22.1152,30.2195 L25.2252,30.2195 C25.8772,30.2195 26.4082,30.7505 26.4082,31.4025 C26.4082,32.0555 25.8772,32.5865 25.2252,32.5865 L22.1152,32.5865 C21.4632,32.5865 20.9322,32.0555 20.9322,31.4025 M23.6712,48.2845 C20.9242,48.2775 18.6892,46.8335 18.6892,45.0655 C18.6892,43.7255 20.0592,42.4985 22.0072,42.0395 C22.2102,42.5325 22.6302,42.9245 23.1602,43.0805 C23.1722,43.0845 23.1852,43.0885 23.1902,43.0895 C23.2332,43.1015 23.2772,43.1125 23.3202,43.1205 C23.3462,43.1255 23.3712,43.1295 23.3972,43.1335 L23.4122,43.1355 C23.4132,43.1355 23.4242,43.1375 23.4252,43.1375 C23.4472,43.1415 23.4702,43.1445 23.4912,43.1465 C23.6092,43.1585 23.7322,43.1585 23.8472,43.1465 C23.8702,43.1445 23.8932,43.1415 23.9162,43.1375 L23.9432,43.1335 C23.9682,43.1295 23.9942,43.1255 24.0192,43.1215 C24.0632,43.1125 24.1072,43.1015 24.1432,43.0905 C24.1522,43.0885 24.1722,43.0835 24.1802,43.0805 C24.7102,42.9245 25.1302,42.5325 25.3332,42.0395 C27.2812,42.4985 28.6512,43.7255 28.6512,45.0655 C28.6512,46.8335 26.4162,48.2775 23.6712,48.2845 M18.6482,51.6315 C18.1372,51.6315 17.7212,51.2165 17.7212,50.7045 C17.7212,50.1935 18.1372,49.7775 18.6482,49.7775 C19.1592,49.7775 19.5752,50.1935 19.5752,50.7045 C19.5752,51.2165 19.1592,51.6315 18.6482,51.6315 M28.6922,51.6315 C28.1812,51.6315 27.7652,51.2165 27.7652,50.7045 C27.7652,50.1935 28.1812,49.7775 28.6922,49.7775 C29.2032,49.7775 29.6192,50.1935 29.6192,50.7045 C29.6192,51.2165 29.2032,51.6315 28.6922,51.6315 M32.9172,35.5045 C35.3802,35.5045 36.9722,37.3015 36.9722,40.0805 C36.9722,41.7505 35.3852,42.9805 33.9852,44.0655 C33.0382,44.7995 32.0592,45.5585 32.0592,46.1345 C32.0592,47.0325 32.4812,47.6475 32.8892,48.2425 C33.2192,48.7245 33.5312,49.1795 33.5312,49.7185 C33.5312,50.5365 32.6772,50.9005 31.9912,51.1945 C31.7272,51.3075 31.2902,51.4935 31.2002,51.6145 C31.1922,51.7255 31.1972,51.8795 31.2032,52.0415 C31.2232,52.6375 31.2502,53.4535 30.7182,54.0035 C30.3932,54.3395 29.9192,54.5105 29.3092,54.5105 C27.8922,54.5105 27.4332,53.7485 27.0282,53.0765 C26.8122,52.7185 26.6092,52.3805 26.2522,52.1035 C25.2412,51.3205 23.6852,51.3055 23.6692,51.3055 C23.6552,51.3055 22.0992,51.3205 21.0882,52.1035 C20.7312,52.3805 20.5272,52.7185 20.3122,53.0765 C19.9072,53.7485 19.4482,54.5105 18.0312,54.5105 C17.4212,54.5105 16.9472,54.3395 16.6222,54.0035 C16.0902,53.4535 16.1172,52.6375 16.1372,52.0415 C16.1422,51.8795 16.1472,51.7255 16.1402,51.6145 C16.0492,51.4935 15.6132,51.3075 15.3492,51.1945 C14.6632,50.9015 13.8092,50.5365 13.8092,49.7185 C13.8092,49.1795 14.1212,48.7245 14.4512,48.2425 C14.8592,47.6475 15.2812,47.0325 15.2812,46.1345 C15.2812,45.5585 14.3022,44.7995 13.3552,44.0655 C11.9552,42.9805 10.3682,41.7505 10.3682,40.0805 C10.3682,37.3015 11.9602,35.5045 14.4232,35.5045 C16.7152,35.5045 18.1132,35.7745 20.3382,37.3775 C21.9822,38.5625 23.1922,39.2555 23.6702,39.5165 C24.1482,39.2555 25.3572,38.5625 27.0022,37.3775 C29.2272,35.7745 30.6252,35.5045 32.9172,35.5045 Z M59.7318,38.2021 C61.7278,36.4301 62.9718,34.1491 64.1328,31.8251 C64.4608,31.1701 64.7768,30.5091 65.0878,29.8451 C65.1888,29.6281 65.4188,29.5041 65.6548,29.5361 C66.1918,29.6081 66.7188,29.7121 67.2338,29.8441 C67.5548,29.9261 67.7218,30.2801 67.5898,30.5841 C66.7578,32.4981 65.9558,34.4251 65.1718,36.3591 C64.6708,37.5961 64.7918,38.8131 65.5518,39.9721 C66.2748,41.0751 66.1608,42.2031 65.3288,43.2091 C64.5808,44.1141 62.8218,44.1251 62.4138,43.0261 C62.1068,42.1971 61.4328,41.9031 60.5668,41.8801 C59.3908,41.8481 58.6178,40.8321 58.9348,39.6931 C59.0838,39.1581 59.3338,38.5561 59.7318,38.2021 Z M68.0712,45.6904 C67.3112,47.0104 67.5662,48.2004 68.2602,49.3914 C69.1392,50.9004 70.0262,52.4044 70.9152,53.9074 C71.1752,54.3464 71.0272,54.9164 70.5832,55.1674 C70.1942,55.3884 69.7932,55.5914 69.3822,55.7744 C68.9492,55.9664 68.4402,55.7974 68.2102,55.3844 C68.1462,55.2694 68.0822,55.1554 68.0172,55.0424 C66.7892,52.8854 65.5702,50.7174 63.8452,48.9004 C63.3052,48.3314 62.7662,47.8124 61.8202,48.2284 C61.2812,48.4654 60.7932,48.0324 60.5032,47.5664 C59.8722,46.5514 59.8432,45.4824 60.3952,44.4204 C60.6702,43.8944 61.1212,43.7024 61.6622,44.0164 C63.0992,44.8474 64.4022,44.5964 65.7002,43.6634 C66.5842,43.0284 67.1002,43.0534 67.6822,43.5554 C68.2752,44.0674 68.5292,44.8964 68.0712,45.6904 Z M59.8944,42.8613 C60.2564,43.1203 60.3254,43.5063 60.2364,43.6413 C60.0554,43.9163 59.8194,44.1283 59.5264,44.1463 C58.5364,44.1263 57.9074,43.7733 57.5584,43.1733 C56.8274,41.9213 56.5514,40.5603 57.1624,39.1603 C57.2584,38.9393 57.5284,38.6063 57.7764,38.6403 C58.1134,38.6563 58.1394,39.1133 58.1314,39.3423 C58.0754,40.8513 58.6944,41.9803 59.8944,42.8613 Z M71.9394,54.288 C71.7034,54.396 71.5834,54.212 71.5554,54.16 C71.1024,53.411 70.6504,52.661 70.2104,51.904 C69.6464,50.932 69.1984,49.889 68.6064,48.934 C68.0134,47.976 67.7564,47.06 68.4104,46.042 C68.4284,46.015 68.4424,45.981 68.4534,45.947 C68.5534,45.643 68.8744,45.457 69.1714,45.573 C69.6034,45.743 69.7254,46.134 69.5744,46.685 C69.4694,47.066 69.5224,47.568 69.6864,47.933 C70.5444,49.833 71.4354,51.722 72.3284,53.606 L72.3284,53.607 C72.3284,53.607 72.4594,53.858 72.2754,54.033 C72.1644,54.119 72.0584,54.21 71.9394,54.288 Z"
    )
    .attr({
      fill: "#929294",
    });

  const circle4First = circle4.circle(45, 45, 42).attr({
    fill: "none",
    strokeDasharray: "263.76",
    strokeDashoffset: "263.76",
    stroke: colourGrape,
    strokeWidth: "5",
    transform: "scale(1, -1) translate(0, -90) rotate(r89, 45, 45)",
  });

  const scene2 = new ScrollMagic.Scene({
    triggerElement: ".landing-infection-prevention-2",
    offset: 180,
    duration: 400,
    reverse: false,
  }).on("start", function () {
    Snap.animate(
      263.76,
      1,
      function (value) {
        // Snap.animate(263.76, 30, function(value) {
        circle3First.attr({ strokeDashoffset: value });
      },
      3000
    );

    Snap.animate(
      263.76,
      1,
      function (value) {
        circle4First.attr({ strokeDashoffset: value });
      },
      3000
    );

    const num5 = new Odometer({
      el: document.getElementById("num-5"),
      format: "(,ddd).ddd",
    });
    const num6 = new Odometer({
      el: document.getElementById("num-6"),
      format: "(,ddd).ddd",
    });

    num5.update(11.001);
    // num5.update(10.701);
    num6.update(11.001);

    svg2.find(".circle-1").addClass("circle-anim-1");
    svg2.find(".circle-2").addClass("circle-anim-2");
    svg2.find(".circle-3").addClass("circle-anim-3");
    svg2.find(".circle-4").addClass("circle-anim-4");
  });

  if ($("#infectionPreventionGraph").length) {
    $(document).on("mouseenter", ".path-dot", function () {
      $(this).find("circle:first-child")[0].style.transform =
        "translate(-.55%, -.95%) scale(1.25)";
      $(this).find("circle:nth-child(2)")[0].style.transform =
        "translate(-.2%, -.4%) scale(1.1)";
      $(this).find("g")[0].style.opacity = 1;
    });

    $(document).on("mouseleave", ".path-dot", function () {
      $(this).find("circle:first-child")[0].style.transform =
        "translate(0, 0) scale(1)";
      $(this).find("circle:nth-child(2)")[0].style.transform =
        "translate(0, 0) scale(1)";
      $(this).find("g")[0].style.opacity = 0;
    });
  }

  const graph = Snap("#infectionPreventionGraph");
  const bacteriaPath =
    "M19.1166 14.2182C18.4936 14.8412 17.4836 14.8412 16.8606 14.2182L12.6296 9.9872C12.0066 9.3642 12.0066 8.3542 12.6296 7.7312 13.2526 7.1082 14.2626 7.1082 14.8856 7.7312L19.1166 11.9622C19.7396 12.5852 19.7396 13.5952 19.1166 14.2182zM13.3222 9.6137C13.3222 9.4687 13.2042 9.3507 13.0592 9.3507 12.9142 9.3507 12.7962 9.4687 12.7962 9.6137 12.7962 9.7587 12.9142 9.8767 13.0592 9.8767 13.2042 9.8767 13.3222 9.7587 13.3222 9.6137zM15.0561 9.6924C15.0561 9.5044 14.9031 9.3514 14.7151 9.3514 14.5271 9.3514 14.3741 9.5044 14.3741 9.6924 14.3741 9.8804 14.5271 10.0334 14.7151 10.0334 14.9031 10.0334 15.0561 9.8804 15.0561 9.6924zM16.1645 9.7705C16.1645 9.6095 16.0345 9.4795 15.8735 9.4795 15.7125 9.4795 15.5815 9.6095 15.5815 9.7705 15.5815 9.9315 15.7125 10.0615 15.8735 10.0615 16.0345 10.0615 16.1645 9.9315 16.1645 9.7705zM17.5146 10.7578C17.5146 10.5848 17.3746 10.4448 17.2016 10.4448 17.0296 10.4448 16.8896 10.5848 16.8896 10.7578 16.8896 10.9308 17.0296 11.0708 17.2016 11.0708 17.3746 11.0708 17.5146 10.9308 17.5146 10.7578zM15.5819 11.3618C15.5819 11.0278 15.3119 10.7578 14.9779 10.7578 14.6439 10.7578 14.3739 11.0278 14.3739 11.3618 14.3739 11.6958 14.6439 11.9658 14.9779 11.9658 15.3119 11.9658 15.5819 11.6958 15.5819 11.3618zM17.4574 12.6196C17.4574 12.4156 17.2924 12.2506 17.0884 12.2506 16.8834 12.2506 16.7184 12.4156 16.7184 12.6196 16.7184 12.8236 16.8834 12.9896 17.0884 12.9896 17.2924 12.9896 17.4574 12.8236 17.4574 12.6196zM18.4667 11.9306C18.4667 11.7696 18.3367 11.6396 18.1757 11.6396 18.0147 11.6396 17.8837 11.7696 17.8837 11.9306 17.8837 12.0916 18.0147 12.2216 18.1757 12.2216 18.3367 12.2216 18.4667 12.0916 18.4667 11.9306zM14.6293 8.4062C14.6293 8.3162 14.5563 8.2432 14.4663 8.2432 14.3753 8.2432 14.3023 8.3162 14.3023 8.4062 14.3023 8.4962 14.3753 8.5692 14.4663 8.5692 14.5563 8.5692 14.6293 8.4962 14.6293 8.4062zM14.0893 8.3281C14.0893 8.1321 13.9303 7.9731 13.7343 7.9731 13.5383 7.9731 13.3783 8.1321 13.3783 8.3281 13.3783 8.5241 13.5383 8.6831 13.7343 8.6831 13.9303 8.6831 14.0893 8.5241 14.0893 8.3281zM10.7782 19.4223C9.8972 19.4223 9.1832 18.7083 9.1832 17.8273L9.1832 11.8443C9.1832 10.9633 9.8972 10.2483 10.7782 10.2483 11.6592 10.2483 12.3732 10.9633 12.3732 11.8443L12.3732 17.8273C12.3732 18.7083 11.6592 19.4223 10.7782 19.4223zM10.9203 12.4848C10.9203 12.1788 10.6723 11.9308 10.3663 11.9308 10.0603 11.9308 9.8113 12.1788 9.8113 12.4848 9.8113 12.7908 10.0603 13.0388 10.3663 13.0388 10.6723 13.0388 10.9203 12.7908 10.9203 12.4848zM11.9862 12.6977C11.9862 12.5367 11.8562 12.4067 11.6952 12.4067 11.5342 12.4067 11.4032 12.5367 11.4032 12.6977 11.4032 12.8587 11.5342 12.9887 11.6952 12.9887 11.8562 12.9887 11.9862 12.8587 11.9862 12.6977zM11.1762 13.8134C11.1762 13.5624 10.9722 13.3584 10.7212 13.3584 10.4702 13.3584 10.2662 13.5624 10.2662 13.8134 10.2662 14.0644 10.4702 14.2684 10.7212 14.2684 10.9722 14.2684 11.1762 14.0644 11.1762 13.8134zM11.83 15.1919C11.83 15.0109 11.684 14.8649 11.503 14.8649 11.323 14.8649 11.176 15.0109 11.176 15.1919 11.176 15.3729 11.323 15.5189 11.503 15.5189 11.684 15.5189 11.83 15.3729 11.83 15.1919zM10.3661 14.9008C10.3661 14.6688 10.1781 14.4818 9.9471 14.4818 9.7151 14.4818 9.5281 14.6688 9.5281 14.9008 9.5281 15.1328 9.7151 15.3198 9.9471 15.3198 10.1781 15.3198 10.3661 15.1328 10.3661 14.9008zM10.494 16.1015C10.494 15.9135 10.341 15.7605 10.153 15.7605 9.965 15.7605 9.812 15.9135 9.812 16.1015 9.812 16.2895 9.965 16.4425 10.153 16.4425 10.341 16.4425 10.494 16.2895 10.494 16.1015zM11.6947 17.3842C11.6947 17.2412 11.5787 17.1252 11.4357 17.1252 11.2917 17.1252 11.1757 17.2412 11.1757 17.3842 11.1757 17.5272 11.2917 17.6432 11.4357 17.6432 11.5787 17.6432 11.6947 17.5272 11.6947 17.3842zM10.494 17.2812C10.494 17.0932 10.341 16.9402 10.153 16.9402 9.965 16.9402 9.812 17.0932 9.812 17.2812 9.812 17.4692 9.965 17.6222 10.153 17.6222 10.341 17.6222 10.494 17.4692 10.494 17.2812zM5.0102 12.935C4.7232 12.935 4.4312 12.857 4.1692 12.694 3.4212 12.229 3.1922 11.246 3.6572 10.497L7.3802 4.507C7.8452 3.759 8.8292 3.529 9.5772 3.994 10.3262 4.46 10.5552 5.443 10.0902 6.192L6.3662 12.182C6.0642 12.668 5.5432 12.935 5.0102 12.935zM8.934 5.8623C8.934 5.6823 8.788 5.5353 8.607 5.5353 8.427 5.5353 8.28 5.6823 8.28 5.8623 8.28 6.0433 8.427 6.1893 8.607 6.1893 8.788 6.1893 8.934 6.0433 8.934 5.8623zM8.2807 6.9565C8.2807 6.6735 8.0517 6.4445 7.7687 6.4445 7.4867 6.4445 7.2577 6.6735 7.2577 6.9565 7.2577 7.2395 7.4867 7.4685 7.7687 7.4685 8.0517 7.4685 8.2807 7.2395 8.2807 6.9565zM6.3905 7.1269C6.2725 7.1269 6.1775 7.2219 6.1775 7.3399 6.1775 7.4579 6.2725 7.5529 6.3905 7.5529 6.5085 7.5529 6.6035 7.4579 6.6035 7.3399 6.6035 7.2219 6.5085 7.1269 6.3905 7.1269zM6.8734 8.7046C6.8734 8.4536 6.6694 8.2496 6.4184 8.2496 6.1674 8.2496 5.9634 8.4536 5.9634 8.7046 5.9634 8.9556 6.1674 9.1596 6.4184 9.1596 6.6694 9.1596 6.8734 8.9556 6.8734 8.7046zM5.495 9.6777C5.495 9.5717 5.409 9.4857 5.303 9.4857 5.197 9.4857 5.111 9.5717 5.111 9.6777 5.111 9.7837 5.197 9.8697 5.303 9.8697 5.409 9.8697 5.495 9.7837 5.495 9.6777zM7.769 9.813C7.769 9.632 7.623 9.486 7.442 9.486 7.262 9.486 7.115 9.632 7.115 9.813 7.115 9.994 7.262 10.14 7.442 10.14 7.623 10.14 7.769 9.994 7.769 9.813zM8.4228 8.2353C8.4228 8.0543 8.2768 7.9083 8.0958 7.9083 7.9158 7.9083 7.7688 8.0543 7.7688 8.2353 7.7688 8.4163 7.9158 8.5623 8.0958 8.5623 8.2768 8.5623 8.4228 8.4163 8.4228 8.2353zM9.1117 6.9033C9.1117 6.8543 9.0717 6.8143 9.0227 6.8143 8.9737 6.8143 8.9337 6.8543 8.9337 6.9033 8.9337 6.9523 8.9737 6.9923 9.0227 6.9923 9.0717 6.9923 9.1117 6.9523 9.1117 6.9033zM6.7885 11.021C6.7885 10.707 6.5335 10.453 6.2205 10.453 5.9065 10.453 5.6515 10.707 5.6515 11.021 5.6515 11.335 5.9065 11.589 6.2205 11.589 6.5335 11.589 6.7885 11.335 6.7885 11.021zM7.7118 5.521C7.7118 5.356 7.5778 5.223 7.4138 5.223 7.2488 5.223 7.1148 5.356 7.1148 5.521 7.1148 5.686 7.2488 5.819 7.4138 5.819 7.5778 5.819 7.7118 5.686 7.7118 5.521zM5.1679 10.8217C5.1679 10.6177 5.0029 10.4527 4.7979 10.4527 4.5939 10.4527 4.4289 10.6177 4.4289 10.8217 4.4289 11.0257 4.5939 11.1917 4.7979 11.1917 5.0029 11.1917 5.1679 11.0257 5.1679 10.8217z";

  const scene1 = new ScrollMagic.Scene({
    triggerElement: ".landing-infection-prevention-1",
    offset: 180,
    duration: 400,
    reverse: false,
  }).on("start", function () {
    for (let i = 1; i <= 18; i++) {
      let line, dot;

      if (i === 1) {
        line = getLine("M70,160 L98,111");
        dot = getDot(colourYellow, "60 148", "1.6%", "JAN - JUN");
      } else if (i === 2) {
        line = getLine("M98,111 L126,143");
        dot = getDot(colourYellow, "88 100", "2.2%", "JUN - DEC");
      } else if (i === 3) {
        line = getLine("M126,143 L154,159");
        dot = getDot(colourOrange, "118 132", "1.8%", "JAN - JUN");
      } else if (i === 4) {
        line = getLine("M154,159 L182,175");
        dot = getDot(colourOrange, "146 149", "1.6%", "JUN - DEC");
      } else if (i === 5) {
        line = getLine("M182,175 L210,167");
        dot = getDot(colourMandarin, "176 164", "1.4%", "JAN - JUN");
      } else if (i === 6) {
        line = getLine("M210,167 L242,175");
        dot = getDot(colourMandarin, "204 156", "1.5%", "JUN - DEC");
      } else if (i === 7) {
        line = getLine("M242,175 L272,208");
        dot = getDot(colourPink, "232 165", "1.4%", "JAN - JUN");
      } else if (i === 8) {
        line = getLine("M272,208 L300,199");
        dot = getDot(colourPink, "262 196", "1.0%", "JUN - DEC");
      } else if (i === 9) {
        line = getLine("M300,199 L332,183");
        dot = getDot(colourGrape, "292 188", "1.1%", "JAN - JUN");
      } else if (i === 10) {
        line = getLine("M332,183 L358,163");
        dot = getDot(colourGrape, "320 172", "1.3%", "JUN - DEC");
      } else if (i === 11) {
        line = getLine("M358,163 L386,191");
        dot = getDot(colourBlue, "347 152", "1.56%", "JAN - JUN");
      } else if (i === 12) {
        line = getLine("M386,191 L414,199");
        dot = getDot(colourBlue, "376 180", "1.21%", "JUN - DEC");
      } else if (i === 13) {
        line = getLine("M414,199 L442,208");
        dot = getDot(colourTeal, "405, 188", "1.21%", "JAN - JUN");
      } else if (i === 14) {
        line = getLine("M434,208 L470,194");
        dot = getDot(colourTeal, "434, 196", "1.10%", "JUN - DEC");
      } else if (i === 15) {
        line = getLine("M470,194 L500,194");
        dot = getDot(colourGreen, "460, 185", "1.20%", "JAN - JUN");
      } else if (i === 16) {
        line = getLine("M500,194 L528,210");
        dot = getDot(colourGreen, "492, 185", "1.20%", "JUN - DEC");
      } else if (i === 17) {
        line = getLine("M528,210 L556,210");
        dot = getDot(colourYellow, "520, 200", "0.90%", "JAN - JUN");
      } else if (i === 18) {
        dot = getDot(colourYellow, "548, 200", "0.90%", "JUN - DEC");
      }

      setTimeout(
        function () {
          linesAnim(line);
        },
        i === 1 ? 300 : 600 * (i - 1) + 300
      );

      setTimeout(
        function () {
          dotAnim(dot);
        },
        i === 1 ? 0 : 600 * (i - 1)
      );
    }
  });

  function getLine(path) {
    return graph.path(path).attr({
      stroke: "#A9D3EB",
      strokeWidth: 2,
      strokeMiterlimit: "10",
      strokeDasharray: 1000,
      strokeDashoffset: 1000,
    });
  }

  function linesAnim(line) {
    Snap.animate(
      1000,
      0,
      function (value) {
        line.attr({ strokeDashoffset: value });
      },
      2000
    );
  }

  function dotAnim(dot) {
    Snap.animate(
      0,
      1,
      function (value) {
        dot.attr({ opacity: value });
      },
      500
    );
  }

  function getDot(color, translate, percent, dates) {
    const circleStroke = graph.circle(11, 11, 11).attr({
      stroke: color,
      strokeWidth: "0.5",
      fill: "transparent",
    });

    const circle = graph.circle(11, 11, 11).attr({
      fill: color,
    });

    const icon = graph.path(bacteriaPath).attr({
      fill: "#FFF",
    });

    const text1 = graph.text(4, 30, percent).attr({
      fontSize: "6",
      fill: color,
      fontFamily: "Helvetica",
    });

    const text2 = graph.text(0, 36, dates).attr({
      fontSize: "4",
      fill: color,
      fontFamily: "Helvetica",
    });

    const textGroup = graph.g(text1, text2).attr({
      opacity: 0,
    });

    return graph.g(circleStroke, circle, icon, textGroup).attr({
      transform: `translate(${translate})`,
      opacity: 0,
      class: "path-dot",
    });
  }

  controller.addScene([scene1, scene2]);
}

function handHygieneAnimTriggering() {
  const controller = new ScrollMagic.Controller();

  const animationThree = new ScrollMagic.Scene({
    triggerElement: ".landing-hand-hygiene",
    offset: -170,
    reverse: false,
  }).on("start", function () {
    const currentAnimationSpeed = 2000;
    const colourBlue = "#007DB9";
    const colourOrange = "#FC6014";
    const colourGrape = "#692C86";
    const bottleFirst = Snap("#svgBottleFirst");
    const bottleSecond = Snap("#svgBottleSecond");
    // const bottleThird = Snap('#svgBottleThird');

    startAnim(bottleFirst, "#53AADD", colourBlue, "90%", 10);
    startAnim(bottleSecond, "#E0CCE2", colourGrape, "89.7%", 10.3, 15);
    // startAnim(bottleFirst, '#53AADD', colourBlue, '85%', 15);
    // startAnim(bottleSecond, '#E0CCE2', colourGrape, '90%', 10);
    // startAnim(bottleThird, '#FCDCC0', colourOrange, '88.6%', 21.4);

    function startAnim(bottle, colorLight, colorDark, text, y, textX = 23) {
      const bottleBgPath =
        "M23.7119,0.3462 C10.7979,0.3462 0.2919,10.8522 0.2919,23.7662 L0.2919,102.9982 C0.2919,115.9122 10.7979,126.4182 23.7119,126.4182 L47.9119,126.4182 C60.8259,126.4182 71.3319,115.9122 71.3319,102.9982 L71.3319,23.7662 C71.3319,10.8522 60.8259,0.3462 47.9119,0.3462 L23.7119,0.3462 Z";

      const bottleBgLight = bottle.path(bottleBgPath).attr({
        fill: colorLight,
        transform: "translate(2 35)",
      });

      const bottleBgDark = bottle.path(bottleBgPath).attr({
        fill: colorDark,
        fillOpacity: 1,
        transform: "translate(2 35)",
      });

      const bottleText = bottle.text(textX, 99, text).attr({
        fill: "#ffffff",
      });

      const bottlePath = bottle
        .path(
          "M49.48,161.9292 L26.144,161.9292 C11.728,161.9292 0,150.2002 0,135.7842 L0,59.3822 C0,44.9662 11.728,33.2382 26.144,33.2382 L49.48,33.2382 C63.896,33.2382 75.624,44.9662 75.624,59.3822 L75.624,135.7842 C75.624,150.2002 63.896,161.9292 49.48,161.9292 L49.48,161.9292 Z M65.6841132,151.500522 C69.6310338,147.432297 72.064,141.887304 72.064,135.7842 L72.064,59.3822 C72.064,46.9302 61.933,36.7992 49.48,36.7992 L26.144,36.7992 C13.692,36.7992 3.56,46.9302 3.56,59.3822 L3.56,135.7842 C3.56,148.2382 13.692,158.3682 26.144,158.3682 L49.48,158.3682 C53.433445,158.3682 57.1528632,157.34723 60.3883924,155.555057 C61.5432359,152.460588 62.1823,149.067396 62.1823,145.51 L62.1823,56.954 C62.1823,51.614 60.7423,46.645 58.2793,42.5 C64.3203,46.734 68.2803,53.743 68.2803,61.663 L68.2803,140.802 C68.2803,144.655387 67.3426523,148.293122 65.6841132,151.500522 Z M28.1958,11.625 L28.1958,4.01 C28.1958,-0.346 32.6308,0.007 32.6308,0.007 L48.9988,0.007 C54.6508,0.321 59.2748,1.181 59.2748,1.181 C70.2248,3.536 73.2158,5.345 74.9818,6.051 C76.7488,6.758 77.2198,7.425 76.5128,9.466 C75.8068,11.507 73.0988,10.958 73.0988,10.958 C73.0988,10.958 63.4818,8.132 57.3978,7.111 C51.3138,6.091 50.0188,11.625 50.0188,11.625 L28.1958,11.625 Z M52.8056,31.1323 L26.3116,31.1323 L26.3116,20.2733 C26.3116,17.6213 28.4616,15.4713 31.1136,15.4713 L48.0036,15.4713 C50.6556,15.4713 52.8056,17.6213 52.8056,20.2733 L52.8056,31.1323 Z M80.7787,19.6998 C82.4747,22.5008 83.3357,24.8168 83.3357,26.5838 C83.3357,30.1728 80.4167,33.0918 76.8277,33.0918 C73.2397,33.0918 70.3197,30.1728 70.3197,26.5838 C70.3197,24.8178 71.1807,22.5018 72.8777,19.7008 C74.1947,17.5268 75.6587,14.6758 76.4147,13.7478 C76.5157,13.6238 76.6677,13.5518 76.8277,13.5518 C76.9887,13.5518 77.1397,13.6238 77.2407,13.7478 C77.9967,14.6758 79.4617,17.5258 80.7787,19.6998 Z M77.7207,30.6948 C77.8477,30.6628 77.9317,30.5508 77.9217,30.4288 C77.9107,30.3078 77.8087,30.2098 77.6787,30.1958 C75.0517,29.9248 73.0717,27.8668 73.0717,25.4088 C73.0717,25.2678 73.0797,25.1188 73.0967,24.9658 C73.1107,24.8388 73.0207,24.7218 72.8857,24.6918 C72.7507,24.6628 72.6147,24.7318 72.5667,24.8518 C72.2827,25.5628 72.1387,26.1998 72.1387,26.7448 C72.1387,29.0038 74.1167,30.8408 76.5487,30.8408 C76.9457,30.8408 77.3407,30.7918 77.7207,30.6948 Z"
        )
        .attr({
          fill: colorDark,
        });

      const bottleRect = bottle.rect(0, 1, 72, 123).attr({
        fill: "#FFF",
        fillOpacity: 1,
      });

      bottleBgDark.attr({ mask: bottleRect });
      bottleRect.animate({ y: y }, currentAnimationSpeed);
    }
  });

  const animationDoctor = new ScrollMagic.Scene({
    triggerElement: ".landing-doctor-hygiene",
    offset: -270,
    reverse: false,
  }).on("start", function () {
    const currentAnimationSpeed = 2000;
    const colourBlue = "#007DB9";
    const colourOrange = "#FC6014";
    const colourGrape = "#692C86";
    const bottleFirst = Snap("#svgDoctorBottleFirst");
    const bottleSecond = Snap("#svgDoctorBottleSecond");
    // const bottleThird = Snap('#svgDoctorBottleThird');

    startAnim(bottleFirst, "#53AADD", colourBlue, "69.4%", 30.6, 15);
    startAnim(bottleSecond, "#E0CCE2", colourGrape, "80.7%", 19.3, 15);
    // startAnim(bottleFirst, '#53AADD', colourBlue, '63%', 30.6, 23);
    // startAnim(bottleSecond, '#E0CCE2', colourGrape, '79%', 19.3, 23);
    // startAnim(bottleThird, '#FCDCC0', colourOrange, '74.4%', 35.6);

    function startAnim(bottle, colorLight, colorDark, text, y, textX = 15) {
      const bottleBgPath =
        "M23.7119,0.3462 C10.7979,0.3462 0.2919,10.8522 0.2919,23.7662 L0.2919,102.9982 C0.2919,115.9122 10.7979,126.4182 23.7119,126.4182 L47.9119,126.4182 C60.8259,126.4182 71.3319,115.9122 71.3319,102.9982 L71.3319,23.7662 C71.3319,10.8522 60.8259,0.3462 47.9119,0.3462 L23.7119,0.3462 Z";

      const bottleBgLight = bottle.path(bottleBgPath).attr({
        fill: colorLight,
        transform: "translate(2 35)",
      });

      const bottleBgDark = bottle.path(bottleBgPath).attr({
        fill: colorDark,
        fillOpacity: 1,
        transform: "translate(2 35)",
      });

      const bottleText = bottle.text(textX, 99, text).attr({
        fill: "#ffffff",
      });

      const bottlePath = bottle
        .path(
          "M49.48,161.9292 L26.144,161.9292 C11.728,161.9292 0,150.2002 0,135.7842 L0,59.3822 C0,44.9662 11.728,33.2382 26.144,33.2382 L49.48,33.2382 C63.896,33.2382 75.624,44.9662 75.624,59.3822 L75.624,135.7842 C75.624,150.2002 63.896,161.9292 49.48,161.9292 L49.48,161.9292 Z M65.6841132,151.500522 C69.6310338,147.432297 72.064,141.887304 72.064,135.7842 L72.064,59.3822 C72.064,46.9302 61.933,36.7992 49.48,36.7992 L26.144,36.7992 C13.692,36.7992 3.56,46.9302 3.56,59.3822 L3.56,135.7842 C3.56,148.2382 13.692,158.3682 26.144,158.3682 L49.48,158.3682 C53.433445,158.3682 57.1528632,157.34723 60.3883924,155.555057 C61.5432359,152.460588 62.1823,149.067396 62.1823,145.51 L62.1823,56.954 C62.1823,51.614 60.7423,46.645 58.2793,42.5 C64.3203,46.734 68.2803,53.743 68.2803,61.663 L68.2803,140.802 C68.2803,144.655387 67.3426523,148.293122 65.6841132,151.500522 Z M28.1958,11.625 L28.1958,4.01 C28.1958,-0.346 32.6308,0.007 32.6308,0.007 L48.9988,0.007 C54.6508,0.321 59.2748,1.181 59.2748,1.181 C70.2248,3.536 73.2158,5.345 74.9818,6.051 C76.7488,6.758 77.2198,7.425 76.5128,9.466 C75.8068,11.507 73.0988,10.958 73.0988,10.958 C73.0988,10.958 63.4818,8.132 57.3978,7.111 C51.3138,6.091 50.0188,11.625 50.0188,11.625 L28.1958,11.625 Z M52.8056,31.1323 L26.3116,31.1323 L26.3116,20.2733 C26.3116,17.6213 28.4616,15.4713 31.1136,15.4713 L48.0036,15.4713 C50.6556,15.4713 52.8056,17.6213 52.8056,20.2733 L52.8056,31.1323 Z M80.7787,19.6998 C82.4747,22.5008 83.3357,24.8168 83.3357,26.5838 C83.3357,30.1728 80.4167,33.0918 76.8277,33.0918 C73.2397,33.0918 70.3197,30.1728 70.3197,26.5838 C70.3197,24.8178 71.1807,22.5018 72.8777,19.7008 C74.1947,17.5268 75.6587,14.6758 76.4147,13.7478 C76.5157,13.6238 76.6677,13.5518 76.8277,13.5518 C76.9887,13.5518 77.1397,13.6238 77.2407,13.7478 C77.9967,14.6758 79.4617,17.5258 80.7787,19.6998 Z M77.7207,30.6948 C77.8477,30.6628 77.9317,30.5508 77.9217,30.4288 C77.9107,30.3078 77.8087,30.2098 77.6787,30.1958 C75.0517,29.9248 73.0717,27.8668 73.0717,25.4088 C73.0717,25.2678 73.0797,25.1188 73.0967,24.9658 C73.1107,24.8388 73.0207,24.7218 72.8857,24.6918 C72.7507,24.6628 72.6147,24.7318 72.5667,24.8518 C72.2827,25.5628 72.1387,26.1998 72.1387,26.7448 C72.1387,29.0038 74.1167,30.8408 76.5487,30.8408 C76.9457,30.8408 77.3407,30.7918 77.7207,30.6948 Z"
        )
        .attr({
          fill: colorDark,
        });

      const bottleRect = bottle.rect(0, 1, 72, 123).attr({
        fill: "#FFF",
        fillOpacity: 1,
      });

      bottleBgDark.attr({ mask: bottleRect });
      bottleRect.animate({ y: y }, currentAnimationSpeed);
    }
  });
  const animationNational = new ScrollMagic.Scene({
    triggerElement: ".landing-national-hygiene",
    offset: -270,
    reverse: false,
  }).on("start", function () {
    const currentAnimationSpeed = 2000;
    const colourBlue = "#007DB9";
    const colourOrange = "#FC6014";
    const colourGrape = "#692C86";
    const bottleFirst = Snap("#svgNationalBottleFirst");
    const bottleSecond = Snap("#svgNationalBottleSecond");
    // const bottleThird = Snap('#svgDoctorBottleThird');

    startAnim(bottleFirst, "#53AADD", colourBlue, "85.7%", 14.3);
    startAnim(bottleSecond, "#E0CCE2", colourGrape, "87.2%", 12.8);
    // startAnim(bottleFirst, '#53AADD', colourBlue, '82%', 18, 23);
    // startAnim(bottleSecond, '#E0CCE2', colourGrape, '87%', 13, 23);
    // startAnim(bottleThird, '#FCDCC0', colourOrange, '74.4%', 35.6);

    function startAnim(bottle, colorLight, colorDark, text, y, textX = 15) {
      const bottleBgPath =
        "M23.7119,0.3462 C10.7979,0.3462 0.2919,10.8522 0.2919,23.7662 L0.2919,102.9982 C0.2919,115.9122 10.7979,126.4182 23.7119,126.4182 L47.9119,126.4182 C60.8259,126.4182 71.3319,115.9122 71.3319,102.9982 L71.3319,23.7662 C71.3319,10.8522 60.8259,0.3462 47.9119,0.3462 L23.7119,0.3462 Z";

      const bottleBgLight = bottle.path(bottleBgPath).attr({
        fill: colorLight,
        transform: "translate(2 35)",
      });

      const bottleBgDark = bottle.path(bottleBgPath).attr({
        fill: colorDark,
        fillOpacity: 1,
        transform: "translate(2 35)",
      });

      const bottleText = bottle.text(textX, 99, text).attr({
        fill: "#ffffff",
      });

      const bottlePath = bottle
        .path(
          "M49.48,161.9292 L26.144,161.9292 C11.728,161.9292 0,150.2002 0,135.7842 L0,59.3822 C0,44.9662 11.728,33.2382 26.144,33.2382 L49.48,33.2382 C63.896,33.2382 75.624,44.9662 75.624,59.3822 L75.624,135.7842 C75.624,150.2002 63.896,161.9292 49.48,161.9292 L49.48,161.9292 Z M65.6841132,151.500522 C69.6310338,147.432297 72.064,141.887304 72.064,135.7842 L72.064,59.3822 C72.064,46.9302 61.933,36.7992 49.48,36.7992 L26.144,36.7992 C13.692,36.7992 3.56,46.9302 3.56,59.3822 L3.56,135.7842 C3.56,148.2382 13.692,158.3682 26.144,158.3682 L49.48,158.3682 C53.433445,158.3682 57.1528632,157.34723 60.3883924,155.555057 C61.5432359,152.460588 62.1823,149.067396 62.1823,145.51 L62.1823,56.954 C62.1823,51.614 60.7423,46.645 58.2793,42.5 C64.3203,46.734 68.2803,53.743 68.2803,61.663 L68.2803,140.802 C68.2803,144.655387 67.3426523,148.293122 65.6841132,151.500522 Z M28.1958,11.625 L28.1958,4.01 C28.1958,-0.346 32.6308,0.007 32.6308,0.007 L48.9988,0.007 C54.6508,0.321 59.2748,1.181 59.2748,1.181 C70.2248,3.536 73.2158,5.345 74.9818,6.051 C76.7488,6.758 77.2198,7.425 76.5128,9.466 C75.8068,11.507 73.0988,10.958 73.0988,10.958 C73.0988,10.958 63.4818,8.132 57.3978,7.111 C51.3138,6.091 50.0188,11.625 50.0188,11.625 L28.1958,11.625 Z M52.8056,31.1323 L26.3116,31.1323 L26.3116,20.2733 C26.3116,17.6213 28.4616,15.4713 31.1136,15.4713 L48.0036,15.4713 C50.6556,15.4713 52.8056,17.6213 52.8056,20.2733 L52.8056,31.1323 Z M80.7787,19.6998 C82.4747,22.5008 83.3357,24.8168 83.3357,26.5838 C83.3357,30.1728 80.4167,33.0918 76.8277,33.0918 C73.2397,33.0918 70.3197,30.1728 70.3197,26.5838 C70.3197,24.8178 71.1807,22.5018 72.8777,19.7008 C74.1947,17.5268 75.6587,14.6758 76.4147,13.7478 C76.5157,13.6238 76.6677,13.5518 76.8277,13.5518 C76.9887,13.5518 77.1397,13.6238 77.2407,13.7478 C77.9967,14.6758 79.4617,17.5258 80.7787,19.6998 Z M77.7207,30.6948 C77.8477,30.6628 77.9317,30.5508 77.9217,30.4288 C77.9107,30.3078 77.8087,30.2098 77.6787,30.1958 C75.0517,29.9248 73.0717,27.8668 73.0717,25.4088 C73.0717,25.2678 73.0797,25.1188 73.0967,24.9658 C73.1107,24.8388 73.0207,24.7218 72.8857,24.6918 C72.7507,24.6628 72.6147,24.7318 72.5667,24.8518 C72.2827,25.5628 72.1387,26.1998 72.1387,26.7448 C72.1387,29.0038 74.1167,30.8408 76.5487,30.8408 C76.9457,30.8408 77.3407,30.7918 77.7207,30.6948 Z"
        )
        .attr({
          fill: colorDark,
        });

      const bottleRect = bottle.rect(0, 1, 72, 123).attr({
        fill: "#FFF",
        fillOpacity: 1,
      });

      bottleBgDark.attr({ mask: bottleRect });
      bottleRect.animate({ y: y }, currentAnimationSpeed);
    }
  });

  controller.addScene([animationThree, animationDoctor, animationNational]);
}

function bloodClotsPatientsSurvey() {
  const controller = new ScrollMagic.Controller();
  const scene1 = new ScrollMagic.Scene({
    triggerElement: ".blood-clots-patients-survey",
    offset: 50,
    duration: 400,
    reverse: false,
  }).on("start", function (event) {
    tableHandler(".blood-clots-patients-survey");
  });
  function tableHandler(parent) {
    const $parent = $(parent);
    const $items = $parent.find('[data-action="number"]');
    $items.each(function () {
      let $this = $(this);
      let to = $this.data("to");
      let width = 0;
      let interval = setInterval(function () {
        if (width < to) {
          width++;
          $this.text(width);

          if ($this.closest(".progress").length) {
            $this.closest(".progress").css("width", width + "%");
          }
        } else {
          clearInterval(interval);
        }
      }, 20);
    });
  }
  controller.addScene([scene1]);
}

function patientSurveyAnimTriggering() {
  const colourGrape = "#692C86";
  const colourBlue = "#007DB9";

  const controller = new ScrollMagic.Controller();

  const scene1 = new ScrollMagic.Scene({
    triggerElement: ".landing-patient-survey-1",
    offset: 50,
    duration: 400,
    reverse: false,
  }).on("start", function (event) {
    tableHandler(".landing-patient-survey-1");
  });

  const scene2 = new ScrollMagic.Scene({
    triggerElement: ".landing-patient-survey-2",
    offset: 50,
    duration: 400,
    reverse: false,
  }).on("start", function (event) {
    tableHandler(".landing-patient-survey-2");
  });

  function tableHandler(parent) {
    const $parent = $(parent);
    const $items = $parent.find('[data-action="number"]');

    $items.each(function () {
      let $this = $(this);
      let to = $this.data("to");
      let width = 0;

      let interval = setInterval(function () {
        if (width < to) {
          width++;
          $this.text(width);

          if ($this.closest(".progress").length) {
            $this.closest(".progress").css("width", width + "%");
          }
        } else {
          clearInterval(interval);
        }
      }, 20);
    });
  }

  const ps3circle1 = new Ps3CircleHandler("#ps3Circle1", function (target) {
    const path = target
      .path(
        "M38.6409846,44.91675 C38.6579846,44.32375 39.1429846,44.00675 39.8789846,44.00475 C42.1219846,43.99775 48.8969846,43.99975 50.0409846,44.00275 C51.1599846,44.00475 51.5049846,44.35275 51.5069846,45.49275 C51.5096513,47.0640833 51.5099846,54.1170833 51.5079846,66.65175 C51.5069846,67.88275 51.1929846,68.19275 49.9649846,68.19375 C46.6459846,68.19375 43.3279846,68.19475 40.0089846,68.19275 C38.9519846,68.19175 38.6129846,67.85575 38.6109846,66.80175 C38.6079846,64.12375 38.6059846,61.98375 38.6119846,59.30675 C38.6159846,57.73475 39.4539846,56.92875 41.0419846,56.90575 C42.4809846,56.88475 43.9349846,56.95175 45.3549846,56.76675 C47.4729846,56.49175 48.9879846,54.82475 49.3119846,52.68375 C49.6009846,50.77575 48.5559846,48.75675 46.7899846,47.81175 C44.9819846,46.84475 42.7529846,47.12675 41.2379846,48.51475 C40.2139846,49.45075 40.2139846,49.45075 38.6279846,49.33375 C38.6279846,47.83375 38.6009846,46.37475 38.6409846,44.91675 Z M45.3934846,48.95525 C46.7694846,49.31625 47.7494846,50.59725 47.7604846,52.05025 C47.7714846,53.52925 46.8034846,54.80425 45.3714846,55.19325 C43.9874846,55.57025 42.4934846,54.98725 41.7824846,53.70325 C41.5264846,53.24125 41.2364846,53.14125 40.7584846,53.14825 C38.8594846,53.17225 36.9604846,53.15725 35.0604846,53.15725 C33.1164846,53.15725 34.6694846,53.14425 32.7254846,53.16625 C32.1984846,53.17225 31.9884846,53.01525 32.0004846,52.46325 C32.0404846,50.69725 31.8444846,51.01325 33.4544846,51.00625 C37.0694846,50.99025 37.1854846,50.99525 40.8014846,51.00925 C41.2474846,51.01125 41.5194846,50.93025 41.7594846,50.48225 C42.4614846,49.17125 43.9594846,48.57925 45.3934846,48.95525 Z M44.5634846,53.19725 C45.1674846,53.18625 45.6414846,52.71425 45.6564846,52.10725 C45.6724846,51.46625 45.1954846,50.97025 44.5554846,50.96425 C43.9124846,50.95725 43.4264846,51.43925 43.4294846,52.08125 C43.4324846,52.71725 43.9314846,53.20925 44.5634846,53.19725 Z"
      )
      .attr({
        fill: "#929294",
        transform: "translate(4)",
      });
  });
  const ps3circle2 = new Ps3CircleHandler("#ps3Circle2", function (target) {
    const path1 = target
      .path(
        "M11.8463,7.6287 L11.8463,3.7017 C11.8463,2.8867 12.6363,2.9107 12.6363,2.9107 C12.6363,2.9107 16.7343,2.2597 20.5403,2.8867 C30.1393,4.4677 31.2103,7.2337 31.2103,7.6287 C31.2103,7.69616766 31.1987471,7.75211155 31.1795878,7.7985 L32.39,7.7985 C33.0535701,7.7985 33.5915,8.33642987 33.5915,9 C33.5915,9.3531437 33.4391456,9.67070314 33.1965804,9.89053471 C33.1998365,9.92658734 33.2015,9.96309941 33.2015,10 L33.2015,12.917 C33.2015,13.5805701 32.6635701,14.1185 32,14.1185 C31.3364299,14.1185 30.7985,13.5805701 30.7985,12.917 L30.7985,10.2015 L3.2015,10.2015 L3.2015,12.219 C3.2015,12.8825701 2.66357013,13.4205 2,13.4205 C1.33642987,13.4205 0.7985,12.8825701 0.7985,12.219 L0.7985,5 C0.7985,4.33642987 1.33642987,3.7985 2,3.7985 C2.66357013,3.7985 3.2015,4.33642987 3.2015,5 L3.2015,7.7985 L11.9062146,7.7985 C11.8463,7.70843159 11.8463,7.6287 11.8463,7.6287 Z M9.2122,5.332 C7.8842,5.332 6.8082,4.256 6.8082,2.928 C6.8082,1.601 7.8842,0.524 9.2122,0.524 C10.5402,0.524 11.6162,1.601 11.6162,2.928 C11.6162,4.256 10.5402,5.332 9.2122,5.332 Z"
      )
      .attr({ fill: "#929294" });
    const path2 = target
      .path(
        "M10.1638908,7.59619904 L5.02689077,7.71119904 C4.35296261,7.72628601 3.7985,7.18409701 3.7985,6.51 L3.7985,6 C3.7985,5.30244948 4.39053132,4.75151015 5.08628094,4.80160197 L10.2392809,5.17260197 C10.9011379,5.22025361 11.3990497,5.79542398 11.351398,6.45728094 C11.3354553,6.67871757 11.2604641,6.88180279 11.1429338,7.05224487 C10.9334673,7.37221514 10.5751253,7.5869929 10.1638908,7.59619904 Z"
      )
      .attr({ fill: "#B3B4B5" });

    target.g(path1, path2).attr({
      transform: "translate(32 48)",
    });
  });
  const ps3circle3 = new Ps3CircleHandler("#ps3Circle3", function (target) {
    const path1 = target
      .path(
        "M6.98034151,0 C6.85134151,0 6.72834151,0.055 6.64234151,0.152 L0.148341513,7.445 C0.127341513,7.468 -0.00765848749,7.63 0.000341512512,7.945 L0.000341512512,21.38 C0.000341512512,22.694 1.06634151,23.762 2.37534151,23.762 L15.6653415,23.762 C16.9753415,23.762 18.0413415,22.694 18.0413415,21.38 L18.0413415,2.382 C18.0413415,1.069 16.9753415,0 15.6653415,0 L6.98034151,0 Z M16.0603415,21.38 C16.0603415,21.602 15.8833415,21.781 15.6653415,21.781 L2.37534151,21.781 C2.15834151,21.781 1.98134151,21.602 1.98134151,21.38 L1.98134151,8.07 C1.98134151,7.82 2.18334151,7.618 2.43334151,7.618 L4.81634151,7.618 C6.12634151,7.618 7.35634151,6.385 7.35634151,5.071 L7.35634151,2.433 C7.35634151,2.183 7.55934151,1.981 7.80834151,1.981 L15.6653415,1.981 C15.8833415,1.981 16.0603415,2.161 16.0603415,2.382 L16.0603415,21.38 Z"
      )
      .attr({});
    const path2 = target
      .path(
        "M5,10.395 C4.78184752,10.395 4.605,10.2181525 4.605,10 C4.605,9.78184752 4.78184752,9.605 5,9.605 L13.984,9.605 C14.2021525,9.605 14.379,9.78184752 14.379,10 C14.379,10.2181525 14.2021525,10.395 13.984,10.395 L5,10.395 Z M9,7.395 C8.78184752,7.395 8.605,7.21815248 8.605,7 C8.605,6.78184752 8.78184752,6.605 9,6.605 L13.749,6.605 C13.9671525,6.605 14.144,6.78184752 14.144,7 C14.144,7.21815248 13.9671525,7.395 13.749,7.395 L9,7.395 Z M5,12.395 C4.78184752,12.395 4.605,12.2181525 4.605,12 C4.605,11.7818475 4.78184752,11.605 5,11.605 L13.984,11.605 C14.2021525,11.605 14.379,11.7818475 14.379,12 C14.379,12.2181525 14.2021525,12.395 13.984,12.395 L5,12.395 Z M5,14.395 C4.78184752,14.395 4.605,14.2181525 4.605,14 C4.605,13.7818475 4.78184752,13.605 5,13.605 L13.984,13.605 C14.2021525,13.605 14.379,13.7818475 14.379,14 C14.379,14.2181525 14.2021525,14.395 13.984,14.395 L5,14.395 Z M5,16.395 C4.78184752,16.395 4.605,16.2181525 4.605,16 C4.605,15.7818475 4.78184752,15.605 5,15.605 L13.984,15.605 C14.2021525,15.605 14.379,15.7818475 14.379,16 C14.379,16.2181525 14.2021525,16.395 13.984,16.395 L5,16.395 Z M5,18.395 C4.78184752,18.395 4.605,18.2181525 4.605,18 C4.605,17.7818475 4.78184752,17.605 5,17.605 L13.984,17.605 C14.2021525,17.605 14.379,17.7818475 14.379,18 C14.379,18.2181525 14.2021525,18.395 13.984,18.395 L5,18.395 Z"
      )
      .attr({
        fillRule: "nonzero",
      });

    target.g(path1, path2).attr({
      fill: "#929294",
      transform: "translate(40 43)",
    });
  });
  const ps3circle4 = new Ps3CircleHandler("#ps3Circle4", function (target) {
    const path = target
      .path(
        "M52.257,66.1373 C52.257,66.9253 52.235,66.8293 51.66,66.8293 C47.5,66.8293 43.34,66.8293 39.18,66.8293 C38.575,66.8293 38.453,66.6863 38.541,66.0833 C38.3,66.0833 42.271,65.5153 42.93,65.4643 C43.007,64.7643 43.984,53.6223 44.383,49.7753 C44.415,49.4673 44.536,49.3483 44.838,49.3163 C45.221,49.2773 45.601,49.1943 45.978,49.1123 C46.238,49.0553 46.362,49.1233 46.391,49.4023 C46.665,52.0403 47.874,65.3323 47.91,65.5313 C48.374,65.5313 52.257,66.1373 52.257,66.1373 Z M57.7638,56.3382 C58.4408,56.3382 58.5478,56.4792 58.3848,57.1292 C58.1938,57.8922 57.7258,58.4522 57.0988,58.8992 C55.5248,60.0232 53.0828,59.9932 51.5298,58.8392 C50.8468,58.3322 50.4408,57.6832 50.3058,56.8482 C50.1588,56.3372 50.8338,56.3572 50.9568,56.3422 C50.9718,56.3422 50.9888,56.3402 51.0038,56.3402 C53.2578,56.3362 55.5108,56.3372 57.7638,56.3382 Z M53.3581,52.321 C52.7831,53.374 52.2081,54.428 51.6321,55.481 C51.5661,55.601 51.4981,55.723 51.4151,55.832 C51.2331,56.074 50.9891,56.131 50.7161,56.015 C50.4211,55.889 50.3611,55.624 50.4341,55.356 C50.5021,55.108 50.6311,54.872 50.7551,54.643 C51.7331,52.836 52.7161,51.031 53.7001,49.226 C53.8451,48.96 53.9761,48.676 54.3541,48.675 C54.7301,48.674 54.8681,48.951 55.0131,49.218 C56.0631,51.144 57.1111,53.071 58.1581,54.998 C58.1981,55.07 58.2341,55.144 58.2691,55.22 C58.4091,55.522 58.3821,55.787 58.0771,55.972 C57.7621,56.163 57.4731,56.09 57.2851,55.796 C57.0111,55.366 56.7721,54.914 56.5271,54.466 C55.8851,53.292 55.2491,52.115 54.6091,50.94 C54.5391,50.812 54.4611,50.689 54.3511,50.503 C54.0001,51.146 53.6781,51.733 53.3581,52.321 Z M39.8497,59.3421 C40.5267,59.3421 40.6337,59.4831 40.4707,60.1331 C40.2797,60.8961 39.8117,61.4561 39.1857,61.9031 C37.6107,63.0271 35.1687,62.9971 33.6157,61.8431 C32.9337,61.3361 32.5277,60.6871 32.3917,59.8521 C32.2447,59.3411 32.9197,59.3611 33.0427,59.3461 C33.0577,59.3461 33.0747,59.3441 33.0897,59.3441 C35.3437,59.3401 37.5967,59.3411 39.8497,59.3421 Z M35.4431,55.3249 C34.8681,56.3779 34.2941,57.4319 33.7181,58.4849 C33.6521,58.6049 33.5841,58.7269 33.5011,58.8359 C33.3191,59.0779 33.0741,59.1349 32.8021,59.0189 C32.5071,58.8929 32.4471,58.6279 32.5201,58.3599 C32.5881,58.1119 32.7171,57.8759 32.8411,57.6469 C33.8191,55.8399 34.8021,54.0349 35.7861,52.2299 C35.9311,51.9639 36.0621,51.6799 36.4401,51.6789 C36.8161,51.6779 36.9541,51.9549 37.0991,52.2219 C38.1491,54.1479 39.1971,56.0749 40.2441,58.0019 C40.2841,58.0739 40.3201,58.1479 40.3551,58.2239 C40.4941,58.5259 40.4681,58.7909 40.1631,58.9759 C39.8481,59.1669 39.5591,59.0939 39.3711,58.7999 C39.0971,58.3699 38.8581,57.9179 38.6131,57.4699 C37.9711,56.2959 37.3351,55.1189 36.6951,53.9439 C36.6251,53.8159 36.5471,53.6929 36.4371,53.5069 C36.0861,54.1499 35.7641,54.7369 35.4431,55.3249 Z M45.2538,43.2085 C46.2618,43.2405 47.0978,43.5585 47.7148,44.2685 C48.3248,44.9705 49.0658,45.2505 49.9578,45.1865 C51.2108,45.0965 52.4658,45.0195 53.7128,44.8725 C54.8078,44.7445 55.5458,45.2375 55.5278,46.1855 C55.5178,46.7045 55.2668,47.0875 54.8148,47.3155 C54.3858,47.5315 53.8868,47.5955 53.5218,47.2715 C52.9318,46.7455 52.3058,46.8005 51.6208,46.9405 C47.3858,47.8035 43.1218,48.4955 38.8418,49.0935 C38.3898,49.1565 38.0508,49.3635 37.8038,49.7605 C37.4408,50.3415 36.7728,50.5755 36.1918,50.3605 C35.6338,50.1555 35.2498,49.5665 35.3048,49.0005 C35.3678,48.3435 35.8228,47.9215 36.5058,47.7615 C37.8328,47.4495 39.1558,47.1115 40.4708,46.7505 C41.2568,46.5355 41.7958,46.0335 42.1328,45.2605 C42.7308,43.8885 43.8628,43.2815 45.2538,43.2085 Z M45.1378,46.9165 C45.6688,46.9095 46.1228,46.4615 46.1258,45.9425 C46.1288,45.3985 45.6528,44.9265 45.1188,44.9455 C44.5868,44.9645 44.1468,45.4225 44.1568,45.9455 C44.1668,46.4855 44.6108,46.9245 45.1378,46.9165 Z"
      )
      .attr({
        fill: "#929294",
        transform: "translate(4)",
      });
  });
  const ps3circle5 = new Ps3CircleHandler("#ps3Circle5", function (target) {
    const path = target
      .path(
        "M45,67 C38.3724576,67 33,61.6277584 33,55.0004823 C33,48.3722416 38.3724576,43 45,43 C51.6275424,43 57,48.3722416 57,55.0004823 C57,61.6277584 51.6275424,67 45,67 Z M46.4819,49.3957 L46.4819,49.0867 C46.4819,47.9407 46.0999,47.3957 45.0639,47.3957 L44.9729,47.3957 C43.9719,47.3957 43.5539,47.9777 43.5539,49.0867 L43.5539,49.4867 C41.5899,49.9047 40.4629,51.1417 40.4629,52.9597 C40.4629,55.4697 42.7359,56.0877 44.2269,56.3967 C45.2999,56.6337 46.1549,56.7967 46.1549,57.4337 C46.1549,57.9967 45.6819,58.2877 44.6449,58.2877 C43.4449,58.2877 42.0449,57.6877 41.2989,57.0337 C41.2269,56.9427 40.2079,57.7067 40.2079,58.6517 C40.2079,59.8157 41.3719,60.6707 43.5359,60.9067 L43.5359,61.2707 C43.5359,62.4157 43.9179,62.9617 44.9539,62.9617 L45.0449,62.9617 C46.0459,62.9617 46.4639,62.3797 46.4639,61.2707 L46.4639,60.8157 C48.5549,60.4157 49.6829,59.1787 49.6829,57.2697 C49.6829,54.8697 47.3549,54.1967 45.8089,53.8877 C44.6639,53.6327 43.8089,53.4877 43.8089,52.8687 C43.8089,52.3237 44.2629,52.0147 45.2639,52.0147 C46.2999,52.0147 47.4639,52.5057 48.2639,53.2327 C48.3369,53.3057 49.4279,52.5237 49.4279,51.5237 C49.4279,50.4137 48.4279,49.6317 46.4819,49.3957 Z"
      )
      .attr({
        fill: "#929294",
        transform: "translate(4)",
      });
  });
  const ps3circle6 = new Ps3CircleHandler("#ps3Circle6", function (target) {
    const path = target
      .path(
        "M45.1108,42.6101 C47.7718,42.6101 49.9348,44.7491 49.9348,47.3791 C49.9348,50.0091 47.7668,52.1481 45.1108,52.1481 C42.4498,52.1481 40.2858,50.0091 40.2858,47.3791 C40.2858,44.7491 42.4498,42.6101 45.1108,42.6101 Z M50.041,57.0165 C50.041,56.8745 49.927,56.7595 49.787,56.7595 C49.647,56.7595 49.533,56.8745 49.533,57.0165 L49.533,65.2655 C49.533,65.6575 49.263,65.9915 48.886,66.0825 C47.744,66.3565 46.554,66.5045 45.33,66.5045 C44.105,66.5045 42.915,66.3565 41.773,66.0825 C41.396,65.9915 41.126,65.6575 41.126,65.2655 L41.126,57.0165 C41.126,56.8745 41.012,56.7595 40.872,56.7595 C40.732,56.7595 40.618,56.8745 40.618,57.0165 L40.618,64.2755 C40.618,64.2755 40.618,64.7285 40.11,64.6645 C38.942,64.4235 38.06,63.3775 38.06,62.1275 L38.06,56.7035 C38.06,54.8105 39.579,53.2765 41.453,53.2765 L49.205,53.2765 C51.08,53.2765 52.599,54.8115 52.599,56.7035 L52.599,62.1275 C52.599,63.3775 51.717,64.4235 50.549,64.6645 C50.041,64.7285 50.041,64.2755 50.041,64.2755 L50.041,57.0165 Z M45.386,61.055 L48.718,56.461 C48.912,56.193 48.853,55.819 48.585,55.624 C48.317,55.43 47.943,55.49 47.749,55.757 L45.24,59.216 C45.054,59.472 44.683,59.502 44.458,59.278 L43.597,58.417 C43.364,58.183 42.985,58.183 42.751,58.417 C42.517,58.651 42.517,59.03 42.751,59.264 L44.604,61.117 C44.828,61.341 45.2,61.312 45.386,61.055 Z"
      )
      .attr({
        fill: "#929294",
        transform: "translate(4)",
      });
  });

  const scene31 = new ScrollMagic.Scene({
    triggerElement: "#landingPatient3-1",
    offset: 180,
    duration: 400,
    reverse: false,
  }).on("start", function () {
    ps3circle1.start([10, 20, 12]);
    ps3circle2.start([20, 24, 12]);

    const num11 = new Odometer({
      el: document.getElementById("num-1-1"),
      animation: "count",
      duration: 3000,
      value: 100,
    });
    const num12 = new Odometer({
      el: document.getElementById("num-1-2"),
      animation: "count",
      duration: 3000,
      value: 100,
    });
    const num13 = new Odometer({
      el: document.getElementById("num-1-3"),
      animation: "count",
      duration: 3000,
      value: 100,
    });

    const num21 = new Odometer({
      el: document.getElementById("num-2-1"),
      animation: "count",
      duration: 3000,
      value: 100,
    });
    const num22 = new Odometer({
      el: document.getElementById("num-2-2"),
      animation: "count",
      duration: 3000,
      value: 100,
    });
    const num23 = new Odometer({
      el: document.getElementById("num-2-3"),
      animation: "count",
      duration: 3000,
      value: 100,
    });

    num11.update(199);
    num12.update(195);
    num13.update(198);

    num21.update(198);
    num22.update(192);
    num23.update(198);
  });

  const scene32 = new ScrollMagic.Scene({
    triggerElement: "#landingPatient3-2",
    offset: 180,
    duration: 400,
    reverse: false,
  }).on("start", function () {
    ps3circle3.start([10, 24, 12]);
    ps3circle4.start([30, 32, 16]);

    const num31 = new Odometer({
      el: document.getElementById("num-3-1"),
      animation: "count",
      duration: 3000,
      value: 100,
    });
    const num32 = new Odometer({
      el: document.getElementById("num-3-2"),
      animation: "count",
      duration: 3000,
      value: 100,
    });
    const num33 = new Odometer({
      el: document.getElementById("num-3-3"),
      animation: "count",
      duration: 3000,
      value: 100,
    });

    const num41 = new Odometer({
      el: document.getElementById("num-4-1"),
      animation: "count",
      duration: 3000,
      value: 100,
    });
    const num42 = new Odometer({
      el: document.getElementById("num-4-2"),
      animation: "count",
      duration: 3000,
      value: 100,
    });
    const num43 = new Odometer({
      el: document.getElementById("num-4-3"),
      animation: "count",
      duration: 3000,
      value: 100,
    });

    num31.update(197);
    num32.update(193);
    num33.update(198);

    num41.update(196);
    num42.update(191);
    num43.update(196);
  });

  const scene33 = new ScrollMagic.Scene({
    triggerElement: "#landingPatient3-3",
    offset: 180,
    duration: 400,
    reverse: false,
  }).on("start", function () {
    ps3circle5.start([25, 32, 16]);
    ps3circle6.start([25, 35, 18]);

    const num51 = new Odometer({
      el: document.getElementById("num-5-1"),
      animation: "count",
      duration: 3000,
      value: 100,
    });
    const num52 = new Odometer({
      el: document.getElementById("num-5-2"),
      animation: "count",
      duration: 3000,
      value: 100,
    });
    const num53 = new Odometer({
      el: document.getElementById("num-5-3"),
      animation: "count",
      duration: 3000,
      value: 100,
    });

    const num61 = new Odometer({
      el: document.getElementById("num-6-1"),
      animation: "count",
      duration: 3000,
      value: 100,
    });
    const num62 = new Odometer({
      el: document.getElementById("num-6-2"),
      animation: "count",
      duration: 3000,
      value: 100,
    });
    const num63 = new Odometer({
      el: document.getElementById("num-6-3"),
      animation: "count",
      duration: 3000,
      value: 100,
    });

    num51.update(195);
    num52.update(189);
    num53.update(195);

    num61.update(193);
    num62.update(186);
    num63.update(192);
  });

  function Ps3CircleHandler(svg, setIcon) {
    const self = this;
    const target = Snap(svg);

    const circleBg1 = target
      .circle(45, 55, 45)
      .attr({ fill: "transparent", stroke: "#FCD6B5", strokeWidth: 7 });
    const circleLine1 = target.circle(45, 55, 45).attr({
      fill: "transparent",
      stroke: "#FC6014",
      strokeWidth: "0.25",
    });
    this.circleProgress1 = target.circle(45, 55, 45).attr({
      fill: "transparent",
      stroke: "#FC6014",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeDasharray: "282.6",
      strokeDashoffset: "282.6",
      transform: "scale(1, -1) translate(0, -100) rotate(89 50 50)",
    });

    const circleBg2 = target
      .circle(45, 55, 35)
      .attr({ fill: "transparent", stroke: "#E5D5E7", strokeWidth: 7 });
    const circleLine2 = target.circle(45, 55, 35).attr({
      fill: "transparent",
      stroke: colourGrape,
      strokeWidth: "0.25",
    });
    this.circleProgress2 = target.circle(45, 55, 35).attr({
      fill: "transparent",
      stroke: colourGrape,
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeDasharray: "219.8",
      strokeDashoffset: "219.8",
      transform: "scale(1, -1) translate(0, -100) rotate(89 50 50)",
    });

    const circleBg3 = target
      .circle(45, 55, 25)
      .attr({ fill: "transparent", stroke: "#C9E4F3", strokeWidth: 7 });
    const circleLine3 = target.circle(45, 55, 25).attr({
      fill: "transparent",
      stroke: colourBlue,
      strokeWidth: "0.25",
    });
    this.circleProgress3 = target.circle(45, 55, 25).attr({
      fill: "transparent",
      stroke: colourBlue,
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeDasharray: "161",
      strokeDashoffset: "161",
      transform: "scale(1, -1) translate(0, -100) rotate(89 50 50)",
    });

    const line = target.path("M47,0 L47,39.476").attr({
      stroke: "#929294",
      strokeDasharray: "0 1.178",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".395",
    });

    const g = target
      .g(
        circleBg1,
        self.circleProgress1,
        circleLine1,
        circleBg2,
        self.circleProgress2,
        circleLine2,
        circleBg3,
        self.circleProgress3,
        circleLine3,
        line
      )
      .attr({
        transform: "translate(4)",
      });

    setIcon(target);
  }

  Ps3CircleHandler.prototype.start = function (values) {
    const progress1 = this.circleProgress1;
    const progress2 = this.circleProgress2;
    const progress3 = this.circleProgress3;

    Snap.animate(
      282.6,
      values[0],
      function (value) {
        progress1.attr({ strokeDashoffset: value });
      },
      3000
    );

    Snap.animate(
      219.8,
      values[1],
      function (value) {
        progress2.attr({ strokeDashoffset: value });
      },
      3000
    );

    Snap.animate(
      157,
      values[2],
      function (value) {
        progress3.attr({ strokeDashoffset: value });
      },
      3000
    );
  };

  const ps4Circle1 = new PsCircleHandler(
    "#ps4Circle1",
    "#DBC4DE",
    "#CBABD0",
    colourGrape,
    true
  );
  const ps4Circle2 = new PsCircleHandler(
    "#ps4Circle2",
    "#FCD6B5",
    "#FAC595",
    "#FC6014",
    true
  );
  const ps4Circle3 = new PsCircleHandler(
    "#ps4Circle3",
    "#B4D9EE",
    "#93C8E7",
    colourBlue,
    true
  );

  const graph = Snap("#patientSurveyGraph");

  const scene4 = new ScrollMagic.Scene({
    triggerElement: ".landing-patient-survey-4",
    offset: 50,
    duration: 400,
    reverse: false,
  }).on("start", function (event) {
    ps4Circle1.start(30, 8000);
    ps4Circle2.start(25, 8000);
    ps4Circle3.start(20, 8000);

    const numHospital = new Odometer({
      el: document.getElementById("num_hospital"),
      animation: "count",
      duration: 8000,
      value: 100,
    });
    const numNurses = new Odometer({
      el: document.getElementById("num_nurses"),
      animation: "count",
      duration: 8000,
      value: 100,
    });
    const numSatisfied = new Odometer({
      el: document.getElementById("num_satisfied"),
      animation: "count",
      duration: 8000,
      value: 100,
    });

    numHospital.update(195);
    numNurses.update(196);
    numSatisfied.update(197);

    for (let i = 1; i <= 13; i++) {
      let line1, line2, line3, dot1, dot2, dot3;

      const line1Color = "#C19AC6";
      const dot1Color = colourGrape;

      const line2Color = "#FAB980";
      const dot2Color = "#FC6014";

      const line3Color = "#7EBEE2";
      const dot3Color = colourBlue;

      if (i === 1) {
        line1 = getLine("M72.7632,71.8343 L170.5112,65.1503", line1Color);
        line2 = getLine("M70.257,65.151 L171.347,59.302", line2Color);
        line3 = null;
        dot1 = getDot("72.5", "71.5", dot1Color);
        dot2 = getDot("72.5", "65.5", dot2Color);
        dot3 = null;
      } else if (i === 2) {
        line1 = getLine("M170.5112,65.1503 L219.8032,71.8343", line1Color);
        line2 = getLine("M171.347,59.302 L220.638,63.48", line2Color);
        line3 = null;
        dot1 = getDot("170.5", "64.5", dot1Color);
        dot2 = getDot("170.5", "60.5", dot2Color);
        dot3 = null;
      } else if (i === 3) {
        line1 = getLine("M219.8032,71.8343 L269.0942,71.8343", line1Color);
        line2 = getLine("M220.638,63.48 L269.095,55.961", line2Color);
        line3 = null;
        dot1 = getDot("220.5", "71.5", dot1Color);
        dot2 = getDot("220.5", "63.5", dot2Color);
        dot3 = null;
      } else if (i === 4) {
        line1 = getLine("M269.0942,71.8343 L319.2212,64.3143", line1Color);
        line2 = getLine("M269.095,55.961 L320.057,64.315", line2Color);
        line3 = null;
        dot1 = getDot("269.5", "71.5", dot1Color);
        dot2 = getDot("269.5", "57.5", dot2Color);
        dot3 = null;
      } else if (i === 5) {
        line1 = getLine("M319.2212,64.3143 L368.5132,58.4673", line1Color);
        line2 = getLine("M320.057,64.315 L369.349,57.631", line2Color);
        line3 = getLine("M318.746,52.894 L368.038,44.54", line3Color);
        dot1 = getDot("319.5", "64.5", dot1Color);
        dot2 = getDot("319.5", "64.5", dot2Color);
        dot3 = getDot("319.5", "50.5", dot3Color);
      } else if (i === 6) {
        line1 = getLine("M368.5132,58.4673 L418.6402,52.6183", line1Color);
        line2 = getLine("M369.349,57.631 L418.64,43.428", line2Color);
        line3 = getLine("M368.038,44.54 L418.165,36.185", line3Color);
        dot1 = getDot("368.5", "57.5", dot1Color);
        dot2 = getDot("368.5", "57.5", dot2Color);
        dot3 = getDot("368.5", "42.5", dot3Color);
      } else if (i === 7) {
        line1 = getLine("M418.6402,52.6183 L467.0962,58.0163", line1Color);
        line2 = getLine("M418.64,43.428 L466.261,50.948", line2Color);
        line3 = getLine("M418.165,36.185 L468.292,43.704", line3Color);
        dot1 = getDot("418.5", "50.5", dot1Color);
        dot2 = getDot("418.5", "45.5", dot2Color);
        dot3 = getDot("418.5", "35.5", dot3Color);
      } else if (i === 8) {
        line1 = getLine("M467.0962,58.0163 L517.2232,58.0163", line1Color);
        line2 = getLine("M466.261,50.948 L518.059,50.112", line2Color);
        line3 = getLine("M468.292,43.704 L516.748,36.185", line3Color);
        dot1 = getDot("467.5", "56.5", dot1Color);
        dot2 = getDot("467.5", "51.5", dot2Color);
        dot3 = getDot("467.5", "42.5", dot3Color);
      } else if (i === 9) {
        line1 = getLine("M517.2232,58.0163 L566.5,50.5", line1Color);
        line2 = getLine("M518.059,50.112 L568.186,44.264", line2Color);
        line3 = getLine("M516.748,36.185 L566.875,35.349", line3Color);
        dot1 = getDot("517.5", "56.5", dot1Color);
        dot2 = getDot("517.5", "51.5", dot2Color);
        dot3 = getDot("517.5", "35.5", dot3Color);
      } else if (i === 10) {
        line1 = getLine("M566.5,50.5 L616.6422,43.4283", line1Color);
        line2 = getLine("M568.186,44.264 L616.643,30.897", line2Color);
        line3 = getLine("M566.875,35.349 L616.167,23.653", line3Color);
        dot1 = getDot("566.5", "50.5", dot1Color);
        dot2 = getDot("566.5", "45.4", dot2Color);
        dot3 = getDot("566.5", "34.5", dot3Color);
      } else if (i === 11) {
        line1 = getLine("M616.6422,43.4283 L665.9342,44.2643", line1Color);
        line2 = getLine("M616.643,30.897 L665.934,32.568", line2Color);
        line3 = getLine("M616.167,23.653 L665.459,32.843", line3Color);
        dot1 = getDot("616.5", "42.5", dot1Color);
        dot2 = getDot("616.5", "30.5", dot2Color);
        dot3 = getDot("616.5", "22.5", dot3Color);
      } else if (i === 12) {
        line1 = getLine("M665.9342,44.2643 L716.8962,44.2643", line1Color);
        line2 = getLine("M665.934,32.568 L715.226,38.416", line2Color);
        line3 = getLine("M665.459,32.843 L716.421,30.722", line3Color);
        dot1 = getDot("665.5", "43.5", dot1Color);
        dot2 = getDot("666.5", "31.5", dot2Color);
        dot3 = getDot("666.5", "31.5", dot3Color);
      } else {
        dot1 = getDot("715.5", "43.5", dot1Color);
        dot2 = getDot("715.5", "38.5", dot2Color);
        dot3 = getDot("715.5", "29.5", dot3Color);
      }

      setTimeout(
        function () {
          dotAnim(dot1);
        },
        i === 1 ? 0 : 600 * (i - 1)
      );

      setTimeout(
        function () {
          dotAnim(dot2);
        },
        i === 1 ? 600 : 600 * (i - 1) + 600
      );

      if (i > 4) {
        setTimeout(
          function () {
            dotAnim(dot3);
          },
          i === 1 ? 3000 : 600 * (i - 1) + 900
        );
      }

      if (i !== 13) {
        setTimeout(
          function () {
            linesAnim(line1);
          },
          i === 1 ? 300 : 600 * (i - 1) + 300
        );

        setTimeout(
          function () {
            linesAnim(line2);
          },
          i === 1 ? 900 : 600 * (i - 1) + 900
        );

        if (i > 4) {
          setTimeout(
            function () {
              linesAnim(line3);
            },
            i === 1 ? 3600 : 600 * (i - 1) + 1200
          );
        }
      }
    }
  });

  function linesAnim(line) {
    Snap.animate(
      600,
      0,
      function (value) {
        line.attr({ strokeDashoffset: value });
      },
      1200
    );
  }

  function getLine(path, color) {
    return graph.path(path).attr({
      stroke: color,
      strokeWidth: "1.671",
      strokeDasharray: 1000,
      strokeDashoffset: 1000,
    });
  }

  function dotAnim(dot) {
    Snap.animate(
      0,
      1,
      function (value) {
        dot.attr({ opacity: value });
      },
      250
    );
  }

  function getDot(cx, cy, color) {
    return graph.circle(cx, cy, "9.5").attr({
      fill: color,
      opacity: 0,
    });
  }

  const ps5Circle1 = new PsCircleHandler(
    "#ps5Circle1",
    "#FCD6B5",
    "#FAC595",
    "#FC6014",
    false
  );
  const ps5Circle2 = new PsCircleHandler(
    "#ps5Circle2",
    "#DBC4DE",
    "#CBABD0",
    colourGrape,
    false
  );
  const ps5Circle3 = new PsCircleHandler(
    "#ps5Circle3",
    "#B4D9EE",
    "#93C8E7",
    colourBlue,
    false
  );

  const scene5 = new ScrollMagic.Scene({
    triggerElement: ".landing-patient-survey-5",
    offset: 50,
    duration: 400,
    reverse: false,
  }).on("start", function (event) {
    ps5Circle1.start(30, 3000);
    ps5Circle2.start(40, 3000);
    ps5Circle3.start(35, 3000);

    const num1 = new Odometer({
      el: document.getElementById("score1"),
      animation: "count",
      duration: 3000,
      value: 100,
      format: "(,ddd).d",
    });
    const num2 = new Odometer({
      el: document.getElementById("score2"),
      animation: "count",
      duration: 3000,
      value: 100,
      format: "(,ddd).d",
    });
    const num3 = new Odometer({
      el: document.getElementById("score3"),
      animation: "count",
      duration: 3000,
      value: 100,
      format: "(,ddd).d",
    });

    num1.update(193);
    num2.update(191.8);
    num3.update(192.5);
  });

  function PsCircleHandler(svg, bgColor, lineColor, progressColor, setIcon) {
    const target = Snap(svg);

    const circleBg = target.circle(63, 75, 63).attr({
      fill: "transparent",
      stroke: bgColor,
      strokeWidth: "16",
    });

    const circleLine = target.circle(63, 75, 63).attr({
      fill: "transparent",
      stroke: lineColor,
    });

    this.circleProgress = target.circle(63, 75, 63).attr({
      fill: "transparent",
      stroke: progressColor,
      strokeWidth: "10",
      strokeLinecap: "round",
      strokeDasharray: "395.64",
      strokeDashoffset: "395.64",
      transform: "scale(1, -1) translate(0, -138) rotate(89 69 69)",
    });

    const line = target.path("M67,0 L67,39.006").attr({
      stroke: "#929294",
      strokeDasharray: "0 2.517",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".835",
    });

    if (setIcon) {
      const icon = target
        .path(
          "M84.018,76.2085736 L90.752,76.3175736 C92.028,76.3385736 92.096,76.5715736 92.096,76.5715736 C92.163,76.8045736 93.248,77.9325736 92.846,79.8425736 C92.426,81.8375736 90.983,82.8075736 90.72,82.9545736 C90.457,83.1015736 90.447,83.0945736 90.447,83.0945736 C90.437,83.0875736 90.414,83.0775736 90.389,83.0775736 L82.706,82.9425736 C82.636,82.9435736 82.581,82.9965736 82.58,83.0645736 C82.579,83.1335736 82.633,83.1895736 82.701,83.1905736 L89.086,83.3025736 C90.363,83.3245736 90.528,83.5425736 90.528,83.5425736 C90.693,83.7605736 91.685,85.3275736 91.002,87.7155736 C90.373,89.9165736 87.75,90.6405736 87.656,90.6655736 C87.562,90.6895736 86.285,90.6555736 86.285,90.6555736 L82.211,90.5475736 C82.139,90.5455736 82.086,90.5995736 82.084,90.6675736 C82.082,90.7365736 82.136,90.7935736 82.204,90.7955736 L86.291,90.9045736 C87.567,90.9385736 87.592,91.3815736 87.592,91.3815736 C87.617,91.8255736 87.669,94.8895736 86.129,95.9885736 C84.321,97.2805736 76.183,98.5725736 71.662,96.7635736 C67.142,94.9555736 67.142,94.9555736 63.957,92.9285736 C62.879,92.2425736 61.616,92.0565736 61.616,92.0565736 C55,91.0805736 56.263,91.2665736 56.263,91.2665736 C55,91.0805736 55,89.8035736 55,89.8035736 L55,72.8535736 C55,71.5765736 56.048,70.8455736 56.048,70.8455736 C63.525,65.6345736 63.525,65.6345736 65.075,64.6015736 C66.625,63.5675736 72.308,52.8465736 73.342,51.4265736 C74.375,50.0055736 79.025,48.8425736 80.058,52.0715736 C81.092,55.3015736 76.571,63.4385736 76.312,64.2135736 C76.054,64.9885736 76.312,67.5715736 79.412,67.7015736 C82.513,67.8305736 89.049,67.8595736 89.823,67.8305736 C93.233,67.7015736 94.267,69.5095736 94.267,71.5765736 C94.267,73.6295736 92.992,75.9355736 92.216,76.0935736 L84.022,75.9605736 L84.02,75.9605736 C83.953,75.9605736 83.897,76.0145736 83.896,76.0825736 C83.895,76.1505736 83.95,76.2075736 84.018,76.2085736 Z M38.671,61 L50.583,61 C52.254,61 52.254,62.671 52.254,62.671 L52.254,94.243 C52.254,95.914 50.583,95.914 50.583,95.914 L38.671,95.914 C37,95.914 37,94.243 37,94.243 L37,62.671 C37,61 38.671,61 38.671,61 Z"
        )
        .attr({
          fill: progressColor,
          transform: "translate(8)",
        });
    }

    target.g(circleBg, circleLine, this.circleProgress, line).attr({
      transform: "translate(8)",
    });
  }

  PsCircleHandler.prototype.start = function (val, speed) {
    const progress = this.circleProgress;

    Snap.animate(
      "395.64",
      val,
      function (value) {
        progress.attr({ strokeDashoffset: value });
      },
      speed
    );
  };

  controller.addScene([
    scene1,
    scene2,
    scene31,
    scene32,
    scene33,
    scene4,
    scene5,
  ]);
}

function isScrolledIntoView(elem) {
  let docViewTop = $(window).scrollTop();
  let docViewBottom = docViewTop + $(window).height();
  let elemTop = $(elem).offset().top;
  return elemTop <= docViewBottom && elemTop >= docViewTop;
}

/*
function initBCAnimation(animated_stuff){

  let counters = $('.counter'),
      people_lines = $('.people_line');

  counters.each((idx, item)=> {
    let $this = $(item),
      el = item,
      start = parseFloat($this.data('start')),
      finish = parseFloat($this.data('finish')),
      duration = parseFloat($this.data('duration')),
      decimals = parseFloat($this.data('decimals')),
      options = {separator: $this.data('separator'), useEasing: false};

    $this.counter_animated = new CountUp(item, start, finish, decimals, duration, options);

    if (isScrolledIntoView($this)) {
      $this.counter_animated.start();
    }
    animated_stuff.push($this);
  });

  people_lines.each((idx,item)=>{
    let $this = $(item),
      endpoint = $this.data('prop');

    $this.css('width', endpoint);

    $this.people_line_animated = {'el': $this,'item': item, 'endpoint': endpoint};

    if (isScrolledIntoView($this)) {
      movePeopleLine($this.people_line_animated);
    }
    animated_stuff.push($this);
  });

  handleScroll(animated_stuff);
}
*/

function movePeopleLine(obj) {
  let el = obj.el,
    item = obj.item,
    endpoint = obj.endpoint;
  item.style.maxWidth = endpoint;
}

$(window).scroll(function () {
  if (scrollTimer) {
    clearTimeout(scrollTimer);
  }
  scrollTimer = setTimeout(handleScroll(animated_stuff), 500);
});

function handleScroll(animated_objects) {
  scrollTimer = null;
  animated_objects.map((item, index) => {
    if (isScrolledIntoView(item)) {
      if (item.hasOwnProperty("counter_animated")) {
        item.counter_animated.start();
      }
      if (item.hasOwnProperty("people_line_animated")) {
        movePeopleLine(item);
      }
    }
  });
}

function bindDownloadLinks() {
  $("a[href*=pdf]").attr("target", "_blank");
}

function initBloodClotsTool() {
  let bct = $("#bc_tool_modal"),
    form = $("#bctool"),
    cb = $("[type=checkbox]", bct).slice(1),
    cb1 = $("#bcrf1"),
    cb1label = cb1.next(),
    submit_btn = $(".submit_btn", bct),
    high = $(".high", bct),
    higher = $(".higher", bct),
    reset = $(".return_link", bct),
    risk = 1,
    mark = $("#mark"),
    close_link = $(".modal_close", bct);

  cb1label.tooltip({ trigger: "manual" });

  cb1.on("change", (e) => {
    e.currentTarget.checked = true;
    cb1label.tooltip("show");
  });

  cb.on("change", (e) => {
    if (e.currentTarget.checked) {
      risk++;
    } else risk--;
    cb1label.tooltip("hide");
  });

  submit_btn.on("click", (e) => {
    if (risk > 1) {
      high.addClass("hidden");
      higher.removeClass("hidden");
    } else {
      higher.addClass("hidden");
      high.removeClass("hidden");
    }
    cb1label.tooltip("hide");
    console.log(mark.offset().top);
    bct.animate(
      {
        scrollTop: form.height(),
      },
      1000
    );
  });

  reset.on("click", (e) => {
    higher.addClass("hidden");
    high.addClass("hidden");
    cb.attr("checked", false);
  });

  close_link.on("click", (e) => {
    higher.addClass("hidden");
    high.addClass("hidden");
    cb.attr("checked", false);
    bct.modal("hide");
  });
}

function bindNestedTabs() {
  let $nested = $("a", ".nested_tabs"),
    $main = $("a", ".main_tabs");

  $nested.on("click", (e) => {
    e.preventDefault();
    let link = $(e.currentTarget).attr("href");

    $main.each((idx, item) => {
      if ($(item).attr("href") === link) {
        $(item).parent().removeClass("active");
        $(link).removeClass("active");
        $(item).trigger("click");
      }
    });
  });
}

function registerTabClicks() {
  
  $("#steps li").click(function (e) {
    e.preventDefault();
    $(window).scrollTop(0);
    var href = $(this).data("href");
    $('.nav-tabs a[href="' + href + '"]').click();
  });

  $(".line_link[href='#patient-admission-forms-and-leaflets']").click(function(e) {
    $('.main_tabs a[href="#patient-admission-forms-and-leaflets"]').tab('show')
    let tabsTop = $('.main_tabs a[href="#patient-admission-forms-and-leaflets"]');
    if (tabsTop.length) {
      $("html, body").animate(
        {
          scrollTop: tabsTop.offset().top - 220,
        },
        1000
      );
    }
  })
}

function sortSpecs() {
  let specs = $(".our_specs"),
    one_spec,
    spec_set = [];

  if (specs.length) {
    // First - sort by speciality
    specs
      .find(".person_box")
      .sort(function (a, b) {
        if (
          $(a).attr("data-spec").toLowerCase() >
          $(b).attr("data-spec").toLowerCase()
        ) {
          return 1;
        } else if (
          $(a).attr("data-spec").toLowerCase() ===
          $(b).attr("data-spec").toLowerCase()
        ) {
          return 0;
        } else {
          return -1;
        }
      })
      .each(function () {
        let elem = $(this);
        elem.remove();
        $(elem).appendTo(specs);
      });

    specs.find(".person_box").each((idx, item) => {
      // Second - sort by surname
      if ($(item).data("spec") === one_spec) {
        // Group people of one speciality
        one_spec = $(item).data("spec");
        spec_set.push(item);
      } else {
        // Sorting
        if (spec_set.length > 1) {

          spec_set.sort(function (a, b) {
            if ( ( $(a).data("surname") == 'faherty' && $(a).data("spec").trim() == 'gynaecology' ) || ($(b).data("surname") == 'faherty' && $(b).data("spec").trim() == 'gynaecology') ) {
              if ( $(a).attr("data-surname") == 'faherty' ) {
                return -1;
              } else {
                return 1;
              }
            }
            if (
              $(a).attr("data-surname").toLowerCase() >
              $(b).attr("data-surname").toLowerCase()
            ) {
              return 1;
            } else if (
              $(a).attr("data-surname").toLowerCase() ===
              $(b).attr("data-surname").toLowerCase()
            ) {
              return 0;
            } else {
              return -1;
            }
          });

          $.each(spec_set, (idx, item) => {
            let elem = $(item);
            elem.remove();
            $(item).appendTo(specs);
          });
        }
        spec_set = [];
        one_spec = $(item).data("spec");
        spec_set.push(item);
      }

      spec_set.sort(function (a, b) {
        if ( ( $(a).data("surname") == 'faherty' && $(a).data("spec").trim() == 'gynaecology' ) || ($(b).data("surname") == 'faherty' && $(b).data("spec").trim() == 'gynaecology') ) {
          if ( $(a).attr("data-surname") == 'faherty' ) {
            return -1;
          } else {
            return 1;
          }
        }
        if (
          $(a).attr("data-surname").toLowerCase() >
          $(b).attr("data-surname").toLowerCase()
        ) {
          return 1;
        } else if (
          $(a).attr("data-surname").toLowerCase() ===
          $(b).attr("data-surname").toLowerCase()
        ) {
          return 0;
        } else {
          return -1;
        }
      }); // Sorting for the last speciality group

      $.each(spec_set, (idx, item) => {
        let elem = $(item);
        elem.remove();
        $(item).appendTo(specs);
      });
    });
  }
}

function sortOtherSpecialistsBySurname() {
  const otherSpecialists = $(".other-specialists .specialist");
  if (otherSpecialists.length) {
    otherSpecialists.sort(function (a, b) {
      if (
        $(a).attr("data-surname").toLowerCase() >
        $(b).attr("data-surname").toLowerCase()
      ) {
        return 1;
      } else if (
        $(a).attr("data-surname").toLowerCase() ===
        $(b).attr("data-surname").toLowerCase()
      ) {
        return 0;
      } else {
        return -1;
      }
    });
  }
  $(".other-specialists .profiles").append(otherSpecialists);
  $(".other-specialists").show();
}

function initFaqCarousel() {
  if ($(".faq_carousel").length) {
    $(".faq_carousel .slider_wrap").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: false,
      rows: 2,
      fade: true,
      slidesPerRow: 2,
      arrows: false,
      dots: true,
      appendDots: $("#slider_navi"),
      autoplay: false,
      cssEase: "ease",
      draggable: true,
      responsive: [
        {
          breakpoint: 2500,
          settings: {
            rows: 2,
            slidesPerRow: 2,
          },
        },
        {
          breakpoint: 768,
          settings: {
            rows: 1,
            slidesPerRow: 1,
          },
        },
      ],
    });
  }
}

function initQuotesCarousel() {
  if ($(".quotes_carousel").length) {
    console.log("asd");
    $(".quotes_carousel .slider_wrap").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 7000,
      fade: true,
      arrows: false,
      dots: true,
      appendDots: $("#quotes_navi"),
      cssEase: "ease",
      draggable: true,
    });
  }
}

function initContentImageSliders() {
  const contentImageSliders = document.querySelectorAll('.content-slider-images .swiper');

  const syncOverlapCarouselSlideHeights = (slider) => {
    const slideContents = slider.querySelectorAll('.content-overlap-carousel-block__slide-content');
    const slides = slider.querySelectorAll('.content-overlap-carousel-block__slide');

    if (!slideContents.length) {
      return;
    }
    let maxHeight = 0;

    slides.forEach((slide) => {
      slide.style.removeProperty('padding-bottom');
    });

    slideContents.forEach((content) => {
      content.style.height = 'auto';
    });

    slideContents.forEach((content) => {
      maxHeight = Math.max(maxHeight, Math.ceil(content.getBoundingClientRect().height));
    });

    if (!maxHeight) {
      return;
    }

    slideContents.forEach((content) => {
      content.style.height = `${maxHeight}px`;
    });
  };

  if ( contentImageSliders.length ) {
    contentImageSliders.forEach(slider => {
      const sliderContainer = slider.closest('.content-slider-images');
      const tabletSlidesPerView = parseFloat(slider.dataset.slidesPerViewTablet || '2');
      const desktopSlidesPerView = parseFloat(slider.dataset.slidesPerViewDesktop || '3');
      const centeredSlides = slider.dataset.centeredSlides === 'true';
      const loop = slider.dataset.loop !== 'false';

      new Swiper(slider, {
        modules: [Autoplay, Navigation],
        navigation: {
          nextEl: sliderContainer ? sliderContainer.querySelector('.swiper-button-next') : '.swiper-button-next',
          prevEl: sliderContainer ? sliderContainer.querySelector('.swiper-button-prev') : '.swiper-button-prev',
        },
        slidesPerView: 1,
        centeredSlides,
        loop,
        loopPreventsSliding: false,
        
        autoplay: false,
        spaceBetween: 30,
        speed: 500,
        on: {
          init(swiper) {
            syncOverlapCarouselSlideHeights(swiper.el);
          },
          resize(swiper) {
            syncOverlapCarouselSlideHeights(swiper.el);
          },
          breakpoint(swiper) {
            syncOverlapCarouselSlideHeights(swiper.el);
          },
        },
        breakpoints: {
          768: {
            slidesPerView: tabletSlidesPerView
          },
          1200: {
            slidesPerView: desktopSlidesPerView
          }
        }
      });
    });
  }
}


function bindRouteToCardLink() {
  const $card = $(".card");

  $card.on("click", (e) => {
    const $current = $(e.currentTarget);
    if (
      $current.find(".card-heading").text().toLowerCase().indexOf("payment") >
      -1
    ) {
      e.preventDefault();
      document.location.href = $current.attr("href") + "&sub=make-a-payment";
    }
  });
}

function handleHomeslide() {
  bindInputFieldFocusState();

  let $slide;

  if ($("#davinci_flag").length > 0) {
    let $links = $("#dv_navbar .nav li"),
      $link_items = $("#dv_navbar a"),
      $learn_more = $("#learn_more"),
      $scrolling_flag = false;

    $slide = $(".homeSlide");

    $("body").imagesLoaded(() => {
      setTimeout(() => {
        let winH = $(window).height() <= 550 ? 550 : $(window).height();

        $slide.height(winH);
        $("body").removeClass("loading").addClass("loaded");
      }, 10);
    });

    if ($(window).width() > 1024) {
      setTimeout(() => {
        var s = skrollr.init({});
        s.refresh($(".homeSlide"));
      }, 1000);
    }

    $link_items.click((e) => {
      e.preventDefault();
      $links.addClass("disabled");
      $learn_more.fadeOut();
      if ($scrolling_flag) {
        return false;
      }
      $scrolling_flag = true;

      let dest = $(e.currentTarget).attr("href");

      $("html,body").animate({ scrollTop: $(dest).offset().top }, 2000, () => {
        $scrolling_flag = false;
        $links.removeClass("disabled");
        $learn_more.fadeIn();
      });
    });

    let $link1 = $("#link1"),
      $link2 = $("#link2"),
      $link3 = $("#link3"),
      $link1xs = $("#link1xs"),
      $link2xs = $("#link2xs"),
      $link3xs = $("#link3xs"),
      $slide1 = $("#slide-1-id"),
      $slide2 = $("#slide-2-id"),
      $slide3 = $("#slide-3-id"),
      $slide1xs = $("#slide-1_xs>.container"),
      $slide2xs = $("#slide-2_xs>.container"),
      $slide3xs = $("#slide-3_xs>.container"),
      $last_slide_mark = $("#last_slide_mark");

    $(window).on("scroll", function () {
      if ($(window).width() > 1199) {
        removeClassFromOneIfOtherIsVisible(
          $slide1,
          $link1,
          $slide1xs,
          "active"
        );
        removeClassFromOneIfOtherIsVisible(
          $slide2,
          $link2,
          $slide2xs,
          "active"
        );
        removeClassFromOneIfOtherIsVisible(
          $slide3,
          $link3,
          $slide3xs,
          "active"
        );
      } else {
        removeClassFromOneIfOtherIsVisible(
          $slide1,
          $link1xs,
          $slide1xs,
          "active"
        );
        removeClassFromOneIfOtherIsVisible(
          $slide2,
          $link2xs,
          $slide2xs,
          "active"
        );
        removeClassFromOneIfOtherIsVisible(
          $slide3,
          $link3xs,
          $slide3xs,
          "active"
        );
      }

      if ($link3.hasClass("active") || inViewport($last_slide_mark)) {
        $learn_more.addClass("moved_down");
      } else {
        $learn_more.removeClass("moved_down");
      }
    });

    $learn_more.click((e) => {
      e.preventDefault();
      if ($(window).width() > 767) {
        $("#dv_navbar .nav li.visible-lg.active")
          .removeClass("active")
          .next()
          .addClass("active")
          .find("a")
          .click();
        console.log(")))");
      } else {
        $("#dv_navbar .nav li.hidden-lg.active")
          .removeClass("active")
          .next()
          .addClass("active")
          .find("a")
          .click();
        console.log(")))");
      }
    });
  }
}

function bindLinkedOptions() {
  let select_element = $("select.linked_options");

  if (select_element.length > 0) {
    select_element.on("change", (e) => {
      if (e.currentTarget.value !== "0") {
        if (
          e.currentTarget.value.indexOf(location.hostname) === -1 &&
          e.currentTarget.value.indexOf("http") !== -1
        ) {
          window.open(e.currentTarget.value, "_blank");
        } else {
          window.location.href = e.currentTarget.value;
        }
      }
    });
  }
}

function bindHospitalDetailModals() {
  const $modal = $("#map_modal");

  if ($modal.length) {
    $modal.on("show.bs.modal", (e) => {
      const $target = $(e.relatedTarget);
      checkGoogleForMap(
        parseFloat($target.data("lat")),
        parseFloat($target.data("lng"))
      );
      $modal.find("#address").html($target.data("address"));
      $modal.find("#parking").html($('.modal-data-parking').html());
      $modal.find("#instructions2 #address2").html($target.data("address"));
      $modal.find("#instructions2 #parking2").html($('.modal-data-parking').html());
    });

    // check for close links and bind click event to them to reset map modal content
    $modal.find(".modal_close, .return_link").on("click", (e) => {
      if (e.target.hash) {
        window.location.hash = e.target.hash;
      }else {
        window.location.href = e.target.href;
      }
      $modal.modal('hide');
    });
  }
}

function bindPersonModals() {
  const $modal = $("#person_modal");

  if ($modal.length) {
    $modal.on("show.bs.modal", (e) => {
      const $target = $(e.relatedTarget);
      $modal.find("#person_image").attr("src", $target.data("image"));
      $modal.find("#person_name").text($target.data("name"));
      $modal.find("#person_position").text($target.data("position"));
      $modal.find("#person_achievments").text($target.data("achievments"));
      $modal.find("#person_description").html($target.data("description"));
    });
  }
}

function checkGoogleForMap(lat, lng) {
  setTimeout(function () {
    if (google) {
      initHDMap(lat, lng);
    } else {
      checkGoogleForMap(lat, lng);
    }
  }, 500);
}

function bindSelect2() {
  let query = {};

  $(".select2")
    .select2({
      minimumResultsForSearch: isMobile ? 100 : 3,
      templateResult: function (item) {
        if (item.loading) {
          return item.text;
        }
        var term = query.term || "";
        var $result = markMatch(item.text, term);
        return $result;
      },
      language: {
        searching: function (params) {
          query = params;
          return "Searching…";
        },
      },
    })
    .on("select2-opening", function () {
      if (isMobile) {
        $(this).siblings(".select2-container").find(".select2-search").remove();
      }
    });
}

function bindFilters() {
  let $filters = $(".filter_item", "#filters");
  const $blocks = $(".person_box");

  $filters.each((idx, item) => {
    const $filter = $(item);

    $filter.click(() => {
      $filters.removeClass("active");
      $filter.addClass("active");

      const word = $filter.data("word");

      if (word === "all") {
        $filters.addClass("active");
      } else {
        $('[data-word="all"]').removeClass("active");
      }

      $(".our_staff.our_specs").empty().append($blocks);
      sortSpecs();
      toggleBlocks(word, $blocks);
    });
  });
}

function toggleBlocks(word, blocks) {
  const $blocks = blocks;

  if (word === "all") {
    $blocks.each((idx, item) => {
      $(item).fadeIn(400);
    });
  } else {
    $blocks.hide();
    $blocks.each((idx, item) => {
      if ($(item).hasClass(word)) {
        $(item).fadeIn(400);
      } else {
        $(item).remove();
      }
    });
  }
}

function bindVideoPlayButtons() {
  document.querySelectorAll('section .video-placeholder').forEach(element => {
    element.addEventListener('click', function() {
        const section = this.closest('section');  // Assuming the <section> is the intended target
        const forVideo = section.querySelector('.for_video');
        forVideo.classList.add('show');
        const iframe = section.querySelector('iframe');
        iframe.src = iframe.dataset.src;
    });
  });
}

function bindDataLinks() {
  $("[data-link]").each((idx, item) => {
    $(item).click((e) => {
      if ($(e.target).parents("a").length > 0) {
        return true;
      } else {
        e.preventDefault();
        e.stopPropagation();
        let targetlink = $(e.currentTarget).data("link");
        if (
          targetlink.indexOf(location.hostname) === -1 &&
          targetlink.indexOf("http") !== -1
        ) {
          window.open(targetlink, "_blank");
        } else {
          window.location = $(e.currentTarget).data("link");
        }
      }
    });
  });
}

function initHDMap(lat, lng) {

  let styles = [
    {
      stylers: [
        {
          color: "#007db9",
        },
        {
          visibility: "simplified",
        },
      ],
    },
    {
      elementType: "geometry",
      stylers: [
        {
          color: "#f5f5f5",
        },
      ],
    },
    {
      elementType: "labels.icon",
      stylers: [
        {
          visibility: "off",
        },
      ],
    },
    {
      elementType: "labels.text.fill",
      stylers: [
        {
          color: "#616161",
        },
      ],
    },
    {
      elementType: "labels.text.stroke",
      stylers: [
        {
          color: "#f5f5f5",
        },
      ],
    },
    {
      featureType: "administrative.land_parcel",
      elementType: "labels.text.fill",
      stylers: [
        {
          color: "#bdbdbd",
        },
      ],
    },
    {
      featureType: "poi",
      elementType: "geometry",
      stylers: [
        {
          color: "#eeeeee",
        },
      ],
    },
    {
      featureType: "poi",
      elementType: "labels.text.fill",
      stylers: [
        {
          color: "#757575",
        },
      ],
    },
    {
      featureType: "poi.business",
      stylers: [
        {
          visibility: "off",
        },
      ],
    },
    {
      featureType: "poi.medical",
      elementType: "geometry",
      stylers: [
        {
          visibility: "simplified",
        },
      ],
    },
    {
      featureType: "poi.medical",
      elementType: "labels",
      stylers: [
        {
          color: "#007db9",
        },
      ],
    },
    {
      featureType: "poi.medical",
      elementType: "labels.icon",
      stylers: [
        {
          color: "#007db9",
        },
        {
          visibility: "off",
        },
      ],
    },
    {
      featureType: "poi.medical",
      elementType: "labels.text",
      stylers: [
        {
          visibility: "simplified",
        },
      ],
    },
    {
      featureType: "poi.park",
      elementType: "geometry",
      stylers: [
        {
          color: "#e5e5e5",
        },
      ],
    },
    {
      featureType: "poi.park",
      elementType: "labels.text.fill",
      stylers: [
        {
          color: "#9e9e9e",
        },
      ],
    },
    {
      featureType: "road",
      elementType: "geometry",
      stylers: [
        {
          color: "#ffffff",
        },
      ],
    },
    {
      featureType: "road.arterial",
      elementType: "labels.text.fill",
      stylers: [
        {
          color: "#757575",
        },
      ],
    },
    {
      featureType: "road.highway",
      elementType: "geometry",
      stylers: [
        {
          color: "#dadada",
        },
      ],
    },
    {
      featureType: "road.highway",
      elementType: "geometry.fill",
      stylers: [
        {
          color: "#007db9",
        },
      ],
    },
    {
      featureType: "road.highway",
      elementType: "labels.text.fill",
      stylers: [
        {
          color: "#ffffff",
        },
        {
          visibility: "simplified",
        },
      ],
    },
    {
      featureType: "road.local",
      elementType: "labels.text.fill",
      stylers: [
        {
          color: "#9e9e9e",
        },
      ],
    },
    {
      featureType: "transit.line",
      elementType: "geometry",
      stylers: [
        {
          color: "#e5e5e5",
        },
      ],
    },
    {
      featureType: "transit.station",
      elementType: "geometry",
      stylers: [
        {
          color: "#eeeeee",
        },
      ],
    },
    {
      featureType: "water",
      elementType: "geometry",
      stylers: [
        {
          color: "#c9c9c9",
        },
      ],
    },
    {
      featureType: "water",
      elementType: "labels.text.fill",
      stylers: [
        {
          color: "#9e9e9e",
        },
      ],
    },
  ];

  let myLatLng = { lat: lat, lng: lng };

  let map = new google.maps.Map(document.getElementById("hdmap"), {
    zoom: 16,
    center: myLatLng,
    //disableDefaultUI: true,
    scaleControl: true,
    styles: styles,
  });

  new google.maps.Marker({
    position: myLatLng,
    map: map,
    icon: "/images/location-icon.png",
  });

  $("#printable_image").attr(
    "src",
    `https://maps.googleapis.com/maps/api/staticmap?markers=${lat},${lng}&zoom=13&size=400x400&key=AIzaSyBckNllNA3hhhEaHo2jLu00-v0WXlu6BiA`
  );
}

function markMatch(text, term) {
  // Find where the match is
  let match = text.toUpperCase().indexOf(term.toUpperCase());

  let $result = $("<span></span>");

  // If there is no match, move on
  if (match < 0) {
    return $result.text(text);
  }

  // Put in whatever text is before the match
  $result.text(text.substring(0, match));

  // Mark the match
  let $match = $('<span class="select2-rendered__match"></span>');
  $match.text(text.substring(match, match + term.length));

  // Append the matching text
  $result.append($match);

  // Put in whatever is after the match
  $result.append(text.substring(match + term.length));

  return $result;
}

function inViewport(element) {
  if (!element.is(":visible")) {
    return false;
  }

  if (typeof jQuery === "function" && element instanceof jQuery) {
    element = element[0];
  }
  let elementBounds = element.getBoundingClientRect();

  let the_offset = $(window).width() > 1200 ? 60 : 60;
  the_offset = $(window).width() < 997 ? 240 : the_offset;
  return (
    elementBounds.top >= 0 &&
    elementBounds.left >= 0 &&
    elementBounds.bottom <= $(window).height() + the_offset &&
    elementBounds.right <= $(window).width()
  );
}

function removeClassFromOneIfOtherIsVisible(
  element,
  element2,
  element3,
  newClass
) {
  if (inViewport(element) || inViewport(element3)) {
    element2.addClass(newClass);
  } else {
    element2.removeClass(newClass);
  }
}

function closeOpenNavigationMenus(onClosed) {
  let $body = $("body"),
    $globalnav = $("#globalNav"),
    $navToggle = $('.navbar-toggle[data-target="#globalNav"]'),
    $dropdowns = $("#globalNav .has-dropdown.is-open");

  let finishClose = () => {
    $body.removeClass("menu_open no_scroll");
    $navToggle.addClass("collapsed").attr("aria-expanded", "false");
    $dropdowns.removeClass("is-open is-mobile-active");
    $dropdowns.children(".dropdown-trigger").attr("aria-expanded", "false");
    $dropdowns.children(".dropdown-menu").attr("aria-hidden", "true");

    if (typeof onClosed === "function") {
      onClosed();
    }
  };

  if ($.fn.collapse && $globalnav.hasClass("in")) {
    $globalnav.one("hidden.bs.collapse.closeNav", () => {
      finishClose();
    });
    $globalnav.collapse("hide");
    return;
  }

  finishClose();
}

function bindScrollLinks() {
  $(
    'a[href*="#"]:not([href="#"]):not([role=tab]):not([data-toggle=collapse])'
  ).click(function () {
    if ( location.pathname.replace(/^\//, "") === this.pathname.replace(/^\//, "") && location.hostname === this.hostname ) {
      let $link = $(this),
        isMobileNavLink = window.matchMedia("(max-width: 991px)").matches &&
          $link.closest("#globalNav").length > 0,
        target = $(this.hash);

      target = target.length ? target : $("[name=" + this.hash.slice(1) + "]");

      if (target.length) {
        let scrollToTarget = () => {
          $("html, body").animate(
            {
              scrollTop: target.offset().top - anchorScrollOffset,
            },
            1000
          );
        };

        if (isMobileNavLink) {
          closeOpenNavigationMenus(scrollToTarget);
        } else {
          scrollToTarget();
        }

        return false;
      }
    }
  });
}

function bindPopupBlocks() {
  $(document).on("click", "[data-popup-target]", function (e) {
    e.preventDefault();
    const targetId = $(this).data("popup-target");
    $("#popup-block-" + targetId).modal("show");
  });
}

function bindPrintButton() {
  let pb = $(".print_button");
  pb.on("click", () => {
    $("#map_modal").printThis({
      debug: false,
      importCSS: true,
      importStyle: true,
      printContainer: true,
      pageTitle: "Address",
      removeInline: false,
      printDelay: 333,
      header: null,
      formValues: true,
    });
  });
}

function bindInputFieldFocusState() {
  let header = $("#gheader"),
    $fields = $("[type=text], [type=email], [type=tel], textarea");

  $fields.on("focus", () => {
    header.addClass("to_hide");
  });
  $fields.on("blur", () => {
    header.removeClass("to_hide");
  });
}

function bindMenuCollapse() {
  let $body = $("body"),
    $globalnav = $("#globalNav"),
    mobileQuery = window.matchMedia("(max-width: 991px)");

  let updateMobileNavHeight = () => {
    if (!$globalnav.length || !mobileQuery.matches) {
      $globalnav.css("--mobile-nav-base-height", "");
      $globalnav.css("--mobile-nav-height", "");
      return;
    }

    let $rootNav = $globalnav.find(".nav-level-1").first(),
      $heightSource = $rootNav.length ? $rootNav : $globalnav.children().first(),
      rootNavHeight = $heightSource.length ? $heightSource[0].scrollHeight : 0,
      navTop = $globalnav[0].getBoundingClientRect().top,
      availableHeight = Math.max(window.innerHeight - navTop + 22, 0);

    $globalnav.css("--mobile-nav-base-height", `${rootNavHeight}px`);

    $globalnav.css("--mobile-nav-height", `${availableHeight}px`);
  };

  $globalnav.on("shown.bs.collapse", () => {
    updateMobileNavHeight();
    $body.addClass("menu_open");
  });
  $globalnav.on("hide.bs.collapse", () => {
    $body.removeClass("menu_open");
  });

  // $globalnav.find('a[href]').off("click.closeMenu").on("click.closeMenu", () => {
  //   if (!mobileQuery.matches) {
  //     console.log("asd");
  //     closeOpenNavigationMenus();
  //   }
  // });

  $(window).on("resize orientationchange", updateMobileNavHeight);
}

function bindMegaDropdowns() {
  let desktopQuery = window.matchMedia("(min-width: 992px)"),
    mobileQuery = window.matchMedia("(max-width: 991px)"),
    $globalnav = $("#globalNav"),
    $dropdowns = $("#globalNav .has-mega-dropdown");

  const navClickSuppressClass = "is-nav-click-suppressed";

  let mobilePanelPlacementTimer = null;

  if (!$dropdowns.length) {
    return;
  }

  let syncMobilePanelState = () => {
    if (!mobileQuery.matches) {
      $globalnav.removeClass("has-mobile-panel");
      $dropdowns.removeClass("is-mobile-active");
      return;
    }

    $globalnav.toggleClass(
      "has-mobile-panel",
      $dropdowns.filter(".is-mobile-active").length > 0
    );
  };

  let setClickedPanel = ($dropdown, panelId) => {
    $dropdown.data("clickedPanelId", panelId || "");
  };

  let getClickedPanel = ($dropdown) => $dropdown.data("clickedPanelId") || "";

  let activatePanel = ($dropdown, panelId) => {
    let $panelTriggers = $dropdown.find(".mega-dropdown-toggle"),
      $panels = $dropdown.find(".mega-dropdown-panel"),
      $panelContainer = $dropdown.find(".mega-dropdown-panel-container").first();

    let queuePanelPlacement = (activePanelId) => {
      if (mobilePanelPlacementTimer) {
        window.clearTimeout(mobilePanelPlacementTimer);
        mobilePanelPlacementTimer = null;
      }

      if (!mobileQuery.matches || !activePanelId) {
        syncPanelPlacement(activePanelId);
        return;
      }

      mobilePanelPlacementTimer = window.setTimeout(() => {
        syncPanelPlacement(activePanelId);
        mobilePanelPlacementTimer = null;
      }, 0);
    };

    let syncPanelPlacement = (activePanelId) => {
      if (!$panelContainer.length) {
        return;
      }

      $panels.each((idx, panel) => {
        let $panel = $(panel),
          currentPanelId = $panel.data("panel"),
          $targetItem = $dropdown
            .find(`.mega-dropdown-toggle[data-panel-target="${currentPanelId}"]`)
            .closest(".nav-item");

        if (mobileQuery.matches && activePanelId && currentPanelId === activePanelId && $targetItem.length) {
          if (!$panel.parent().is($targetItem)) {
            $targetItem.append($panel);
          }
          return;
        }

        if (!$panel.parent().is($panelContainer)) {
          $panelContainer.append($panel);
        }
      });
    };

    if (!panelId) {
      $panelTriggers.removeClass("is-active").attr("aria-pressed", "false");
      $panels.removeClass("is-active");
      queuePanelPlacement("");
      return;
    }

    $panelTriggers.each((idx, trigger) => {
      let $trigger = $(trigger),
        isActive = $trigger.data("panelTarget") === panelId;

      $trigger.toggleClass("is-active", isActive);
      $trigger.attr("aria-pressed", isActive ? "true" : "false");
    });

    $panels.each((idx, panel) => {
      let $panel = $(panel),
        isActive = $panel.data("panel") === panelId;

      $panel.toggleClass("is-active", isActive);
    });

    queuePanelPlacement(panelId);
  };

  let activateDefaultPanel = ($dropdown) => {
    activatePanel($dropdown, "");
  };

  let suppressHoverAndFocusStates = () => {
    $globalnav.addClass(navClickSuppressClass);

    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }
  };

  let clearSuppressedHoverAndFocusStates = () => {
    $globalnav.removeClass(navClickSuppressClass);
  };

  let closeAllDropdowns = () => {
    $dropdowns.each((idx, dropdown) => {
      closeDropdown($(dropdown));
    });
  };

  let closeDropdown = ($dropdown) => {
    $dropdown.removeClass("is-open is-mobile-active");
    $dropdown.children(".dropdown-trigger").attr("aria-expanded", "false");
    $dropdown.children(".dropdown-menu").attr("aria-hidden", "true");
    setClickedPanel($dropdown, "");
    activatePanel($dropdown, "");
    syncMobilePanelState();
  };

  let openDropdown = ($dropdown) => {
    $dropdown.addClass("is-open");
    $dropdown.children(".dropdown-trigger").attr("aria-expanded", "true");
    $dropdown.children(".dropdown-menu").attr("aria-hidden", "false");

    if (mobileQuery.matches) {
      $dropdown.addClass("is-mobile-active");
    }

    syncMobilePanelState();
  };

  $dropdowns.each((idx, dropdown) => {
    let $dropdown = $(dropdown),
      $trigger = $dropdown.children(".dropdown-trigger"),
      $panelTriggers = $dropdown.find(".mega-dropdown-toggle"),
      $panelLinks = $dropdown.find(".mega-dropdown-list > .nav-item > .mega-dropdown-link");

    activateDefaultPanel($dropdown);

    $trigger.on("click", (event) => {
      event.preventDefault();

      if ($dropdown.hasClass("is-open")) {
        closeDropdown($dropdown);
        return;
      }

      $dropdowns.not($dropdown).each((otherIdx, otherDropdown) => {
        closeDropdown($(otherDropdown));
      });
      openDropdown($dropdown);
    });

    $dropdown.find(".mega-dropdown-back").on("click", (event) => {
      event.preventDefault();
      closeDropdown($dropdown);
      $trigger.trigger("focus");
    });

    $dropdown.on("mouseenter", () => {
      if (desktopQuery.matches && !$globalnav.hasClass(navClickSuppressClass)) {
        openDropdown($dropdown);
      }
    });

    $dropdown.on("mouseleave", () => {
      if (desktopQuery.matches) {
        closeDropdown($dropdown);
      }
    });

    $dropdown.on("focusin", () => {
      if (desktopQuery.matches && !$globalnav.hasClass(navClickSuppressClass)) {
        openDropdown($dropdown);
      }
    });

    $panelTriggers.on("mouseenter focusin", function () {
      if ($globalnav.hasClass(navClickSuppressClass)) {
        return;
      }

      let panelId = $(this).data("panelTarget");

      if (panelId) {
        if (!mobileQuery.matches) {
          setClickedPanel($dropdown, "");
        }
        activatePanel($dropdown, panelId);
      }
    });

    $panelLinks.on("mouseenter focusin", function () {
      if (!desktopQuery.matches) {
        return;
      }

      if ($globalnav.hasClass(navClickSuppressClass)) {
        return;
      }

      if (!$(this).data("panelTarget")) {
        activatePanel($dropdown, "");
      }
    });

    $panelTriggers.on("click", function (event) {
      let $trigger = $(this),
        panelId = $trigger.data("panelTarget"),
        isActive = $trigger.hasClass("is-active"),
        clickedPanelId = getClickedPanel($dropdown),
        isClickedActive = clickedPanelId === panelId;

      if (panelId) {
        event.preventDefault();
        openDropdown($dropdown);

        if (isActive && isClickedActive) {
          setClickedPanel($dropdown, "");
          activatePanel($dropdown, "");
          return;
        }

        setClickedPanel($dropdown, panelId);
        activatePanel($dropdown, panelId);
      }
    });

    $dropdown.find('a[href]').off("click.closeDropdown").on("click.closeDropdown", () => {
      suppressHoverAndFocusStates();
      closeAllDropdowns();
    });
  });

  $globalnav.on("mouseleave", () => {
    clearSuppressedHoverAndFocusStates();
  });

  $globalnav.on("hide.bs.collapse", () => {
    closeAllDropdowns();
  });

  $(document).on("click", (event) => {
    if (!$(event.target).closest("#globalNav .has-mega-dropdown").length) {
      closeAllDropdowns();
    }
  });

  $(document).on("keydown", (event) => {
    if (event.key === "Escape") {
      closeAllDropdowns();
    }

    if (event.key === "Tab") {
      clearSuppressedHoverAndFocusStates();
    }
  });

  $(window).on("resize orientationchange", () => {
    syncMobilePanelState();

    if (!mobileQuery.matches) {
      $dropdowns.removeClass("is-mobile-active");
      $dropdowns.children(".dropdown-menu").attr("aria-hidden", "true");
    }

    $dropdowns.each((idx, dropdown) => {
      let $dropdown = $(dropdown),
        $activeTrigger = $dropdown.find(".mega-dropdown-toggle.is-active").first();

      if ($activeTrigger.length) {
        activatePanel($dropdown, $activeTrigger.data("panelTarget"));
      }
    });
  });
}

function bindSearchResults() {
  let $list = $(".results_list"),
    $query = $list.data("query");

  if ($list.length && $query) {
    $list.find("li").each((idx, item) => {
      // let $new_text = $(item).html().replace($query, "<span class='highlighted'>" + $query + "</span>");
      // $(item).html($new_text);
    });
  }
}

function bindMenuSwitcher(context) {
  if ($("#tabs_here").length > 0) {
    let $switcher = $(".menu_switcher", context),
      $nav_links = $("a", ".nav-tabs"),
      $whole_thing = $switcher.parents(context);

    $switcher.on("click", () => {
      $whole_thing.toggleClass("menu_shown");
      // if ($whole_thing.hasClass('menu_shown')) {
      //     let $move = is_landscape ? 50 : 120;
      //
      //     $('html, body').animate({
      //         scrollTop: $switcher.offset().top - $move
      //     }, 300);
      // }
    });

    $nav_links.on("click", () => {
      $whole_thing.removeClass("menu_shown");
    });

    let stage = new Hammer(document.getElementById("tabs_here"), {
      cssProps: {
        userSelect: true,
      },
    });

    stage.on("swiperight", (ev) => {
      $whole_thing.addClass("menu_shown");
      // let $move = is_landscape ? 50 : 120;
      //
      // $('html, body').animate({
      //     scrollTop: $switcher.offset().top - $move
      // }, 300);
    });

    stage.on("swipeleft", (ev) => {
      $whole_thing.removeClass("menu_shown");
    });
  }
}

function bindBackButton() {
  $(".back_link").on("click", () => {
    const redirect = "/specialists-and-services/find-a-specialist";

    if (Request.isPathFoundInUrl(redirect)) {
      window.location.href = redirect;
    } else {
      history.go(-1);
    }
  });
}

function bindSpecialtyLink() {
  const specItem = $(".spec_item");

  // Parse specialty from url query e.g. /patients-and-visitors/auckland-surgical-centre?section=specialists&specialty=general-surgery
  const specialty = Request.getParam("specialty");

  // Add link to the specialty buttons in /patients-and-visitors/auckland-surgical-centre
  if (specItem.length) {
    specItem.on(
      "click",
      (e) => (document.location.href = $(e.currentTarget).data("link"))
    );
  }

  // If specialty found, then trigger to click the specialty item in the search filter
  if (specialty) {
    const $filter = $("#filters").find(
      `.filter_item[data-word="${specialty}"]`
    );
    if ($filter.length) {
      $filter.trigger("click");
      $("html,body").animate(
        { scrollTop: $("main").find("header").offset().top - 130 },
        2500
      );
    }
  }
}

function bindNaviLinks() {
  let navilinks = $(".navi_link"),
    current_url = window.location.href;

  if (navilinks.length > 0) {
    if (current_url.indexOf("section=patient-information") > -1) {
      navilinks.each((idx, item) => {
        let anchor = $(item).attr("href").indexOf("anchor");

        if (anchor > 0) {
          let newlink = $(item).attr("href").substr(anchor),
            piece_0 = current_url.indexOf("anchor");

          if (piece_0 > 1) {
            current_url = current_url.substr(0, piece_0 - 1);
          }
          $(item).attr("href", current_url + "&" + newlink);
        }
      });
    }
  }
}

function bindExternalLinks() {
  $("a").each(function () {
    let a = new RegExp("/" + window.location.host + "/");
    let b = new RegExp("mailto:");
    if (!a.test(this.href) && !b.test(this.href)) {
      $(this).attr("target", "_blank");
    }
  });
}

function sizeTheVideo() {
  let aspectRatio = 1.78;
  let video = $('.landing-favourites div[class^="video-"] iframe');
  let videoHeight = video.outerHeight();
  let newWidth = videoHeight * aspectRatio;
  video.css({ "max-width": newWidth + "px" });
}

function formCheck() {
  const atpField = $(".chars-control");

  atpField.on("keypress", function (e) {
    let allowedChars = "0123456789.";
    function contains(stringValue, charValue) {
      return stringValue.indexOf(charValue) > -1;
    }
    let invalidKey = contains(allowedChars, e.key);
    if (!invalidKey) {
      return false;
    }
  });

}

function hiddenTextTrigger() {
  const textTriggerButton = $(".text-trigger");
  const textTriggerBlock = $(".for-trigger");

  textTriggerButton.click(function (e) {
    e.preventDefault();
    textTriggerButton.toggle();
    textTriggerBlock.toggle();
  });
}

function updateHash() {
  let links = $(".main_tabs a");
  links.on("click", (e) => {
    e.preventDefault();
    let href = $(e.currentTarget).attr("href");
    if (history.pushState) {
      history.pushState(null, null, href);
    } else {
      location.hash = href;
    }
  });
}
function initBannerSlideShow() {
  if ($(".slideshow").first().children().length > 1) {
    $(".slideshow").slick({
      infinite: true,
      arrows: false,
      dots: true,
      // dotsClass: 'slick-dots',
      autoplaySpeed: 10000,
      // appendDots: $('#slider_navi'),
      autoplay: true,
      draggable: true,
    });
  } else {
    $(".slideshow").slick({
      infinite: false,
      arrows: false,
      dots: false,
      // dotsClass: 'slick-dots',
      autoplaySpeed: 10000,
      // appendDots: $('#slider_navi'),
      autoplay: false,
      draggable: false,
    });
  }
}
function bindAccordionToggleButton() {
  $(".accordion-button a").on("click", (e) => {
    e.preventDefault();
    let targetID = e.target.id;
    let accordionID = targetID.replace("accordion-button-", "#");
    if ($("#" + targetID).text() == "Show All") {
      $("#" + targetID).text("Hide All");
      $(accordionID + " .panel-collapse").collapse("show");
    } else {
      $("#" + targetID).text("Show All");
      $(accordionID + " .panel-collapse").collapse("hide");
    }
  });
}

function cwsInfographic() {
  if ( $( "#cws-infographic-bubble-diagram" ).length ) {

    const diagram = $( "#cws-infographic-bubble-diagram" );

    function loadDiagram(resolve, reject) {
        diagram.find( ".circle-main" ).addClass( "loaded" );
        setTimeout(() => {
          diagram.find( ".line" ).addClass( "loaded" );
        }, 1000);
        setTimeout(() => {
          diagram.find( ".circle-secondary" ).addClass( "loaded" );
          resolve( 'done' );
        }, 1500);
    }
      
    function initSwiper(value) {
      if ( value == 'done' ) {
        const diagramSwiper = new Swiper( diagram.children(".swiper")[0], {
          modules: [EffectFade],
          slidesPerView: 1,
          spaceBetween: 30,
          speed: 500,
          effect: "fade",
          fadeEffect: {
              crossFade: true
          },
          on: {
            init: function() {
              $( ".circles-secondary" ).children().eq( 0 ).addClass( "active" )
            }
          }
        })
        diagramSwiper.on('slideChange', e => {
          $( ".circles-secondary" ).children().removeClass( "active" )
          $( ".circles-secondary" ).children().eq( e.activeIndex ).addClass( "active" )
        })
        $(".circles-secondary").on("click", ".circle-secondary", function() {
          const slideIndex = $(this).parent().children().index($(this))
          diagramSwiper.slideTo( slideIndex )
        })
      }
    }

    (new Promise( loadDiagram )).then( initSwiper )

  }
}

function jobsFilter() {
  const jobsContainer = document.querySelector( ".jobs" );
  const jobsLocationFilter = document.querySelector( ".jobs-location-filter" );
  const jobsTypeFilter = document.querySelector( ".jobs-type-filter" );
  const run = function() {
    if ( jobsLocationFilter && jobsTypeFilter ) {
      const location = jobsLocationFilter.value;
      const jobType = jobsTypeFilter.value;
      console.log(location)
      jobsContainer.querySelectorAll( ".job" ).forEach(
        job => {
          let display = "block";
          if ( location != "all" && ! job.classList.contains( location )) {
            display = "none"
          }
          if ( jobType != "all" && ! job.classList.contains( jobType )) {
            display = "none"
          }
          job.style.display = display
        }
      )
    }
  }
  run()
  if ( jobsLocationFilter && jobsTypeFilter ) {
    jobsLocationFilter.addEventListener( "change", e => {
      run()
    })
    jobsTypeFilter.addEventListener( "change", e => {
      run()
    })
  }
}

function ajaxExpressForm( formId ) {

  var safari = navigator.userAgent.indexOf("Safari") > -1

  function ajaxifyForm(event) {
    var form = event.target
    var data = new FormData(form)
    var request = new XMLHttpRequest()

    if (safari) {
      for (var i = 0; i < form.elements.length; i++) {
        if (form.elements[i].type == "file") {
          if (form.elements[i].value == "") {
            var elem = form.elements[i]
            data.delete(elem.name)
          }
        }
      }
    }

    var method = form.getAttribute("method")
    var action = form.getAttribute("action")

    request.open(method, action ? action : window.location.href, true)
    request.setRequestHeader("Cache-Control", "no-cache")
    request.setRequestHeader("X-Requested-With", "XMLHttpRequest")
    request.setRequestHeader("HTTP_X_REQUESTED_WITH", "XMLHttpRequest")
    request.onload = function() {
      removeMessages(form)

      if (request.status === 200) {
        var response = JSON.parse(request.response)

        if (response.success) {
          // Reset the form so that the user may enter fresh information
          form.reset()

          // ============================================================
          // Uncomment this to have the form redirect to the success page
          // ============================================================
          // if (response.return) {
          //   window.location.href = response.return;
          // }

          form.querySelectorAll('.fields, .btn').forEach(
            element => element.classList.add('d-none')
          )
          renderFormSuccess(form)
          window.scrollBy({
            top: -100, 
            left: 0, 
            behavior: 'smooth' 
          });

        } else if (response.errors || response.formErrors) {
          renderErrors(response.errors, form)
          renderFormErrors(response.formErrors, form)
        }

        replaceInputs(form, response);
        unlockSubmit(form)
      } else {
        console.error(request)
      }

      unlockSubmit(form)
    }

    request.send(data)
    event.preventDefault()
  }

  function replaceInputs(form, response) {
    if (response.duplicateCheck) {
      var prefix = response.duplicateCheck.prefix;
      var value = response.duplicateCheck.value;
      var input = form.querySelector('input[name^="' + prefix + '"]');
      if (input) {
        input.setAttribute("name", value);
        input.setAttribute("value", value);
      }
    }
  }

  /**
    * Remove the "disabled" state of the submit button upon successful submit
    *
    * @property form
    */
  function unlockSubmit(form) {
    form.querySelector("input[type=submit]").removeAttribute("disabled")
    if (typeof grecaptcha !== "undefined") {
      grecaptcha.reset()
    }
  }

  function removeMessages(form) {
    // Remove error messages
    form.querySelectorAll("ul.errors").remove()
    var fieldsWithErrors = form.querySelectorAll(".has-error")
    for (var fieldIndex = 0; fieldIndex < fieldsWithErrors.length; fieldIndex++) {
      fieldsWithErrors[fieldIndex].classList.remove("has-error")
    }

    // Remove success messages
    form.querySelectorAll(".form-success").remove()
    document.getElementsByClassName("form-errors").remove()
  }

  function renderFormSuccess(form) {
    var successMessage = document.createElement("div")
    successMessage.classList.add("alert", "alert-success", "form-success")

    successMessage.appendChild(
      document.createTextNode("Form has been submitted successfully!")
    )

    form.insertBefore(successMessage, form.childNodes[0])
  }

  function renderErrors(errors, form) {
    for (var key in errors) {
      if (!errors.hasOwnProperty(key) || !key) {
        continue
      }

      var messages = errors[key]
      var errorsList = document.createElement("ul")
      errorsList.classList.add("errors")

      for (var messageIndex = 0; messageIndex < messages.length; messageIndex++) {
        var message = messages[messageIndex]
        var listItem = document.createElement("li")
        listItem.appendChild(document.createTextNode(message))
        errorsList.appendChild(listItem)
      }

      var inputList = form.querySelectorAll("*[name=" + key + "], *[name='" + key + "[]']")
      for (var inputIndex = 0; inputIndex < inputList.length; inputIndex++) {
        var input = inputList[inputIndex]

        input.findAncestor("form-group").classList.add("has-error")
        input.findAncestor("form-group").appendChild(errorsList)
      }
    }
  }

  function renderFormErrors(errors, form) {
    var errorBlock = document.createElement("div")
    errorBlock.classList.add("alert", "alert-danger", "form-errors")

    errorBlock.appendChild(
      document.createTextNode("Error! Please review the form and try submitting again.")
    )

    if (errors.length) {
      var errorsList = document.createElement("ul")
      for (var messageIndex = 0; messageIndex < errors.length; messageIndex++) {
        var message = errors[messageIndex]
        var listItem = document.createElement("li")

        listItem.appendChild(document.createTextNode(message))
        errorsList.appendChild(listItem)
      }

      errorBlock.appendChild(errorsList)
    }

    form.insertBefore(errorBlock, form.childNodes[0])
  }

  // Add remove prototypes
  Element.prototype.remove = function() {
    this.parentElement.removeChild(this)
  }

  Element.prototype.findAncestor = function(className) {
    let el = this
    while (!el.classList.contains(className)) {
      el = el.parentElement
    }

    return el
  }

  NodeList.prototype.remove = HTMLCollection.prototype.remove = function() {
    for (var i = this.length - 1; i >= 0; i--) {
      if (this[i] && this[i].parentElement) {
        this[i].parentElement.removeChild(this[i])
      }
    }
  }

  document.getElementById( formId ).addEventListener("submit", ajaxifyForm)
}

function initFormValidation() {
  
}